"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* global self */
// create the global namespace for the aviation fatigue meter
var afm = {}; // test to see if code is running in a node server

afm.is_node = typeof module !== 'undefined' && module.exports != null; // if running in node, explicitly load dependencies

if (afm.is_node) {
  global.d3 = require('d3');
} // determine what to do with the the afm object
// when in browser, attach afm object to window


if (typeof window !== 'undefined' && window !== null) {
  window.afm = afm; // when in node, export the afm object
} else if (afm.is_node) {
  module.exports.afm = afm; // else it must be a web worker, so attach afm to the global object
} else {
  self.afm = afm;
}
/* global afm */


afm.AirportProcessor = /*#__PURE__*/function () {
  function AirportProcessor() {
    _classCallCheck(this, AirportProcessor);
  }

  _createClass(AirportProcessor, null, [{
    key: "initialize",
    value: function initialize() {
      this.create_airport_maps_and_codes();
      afm.airports = undefined; // clear temporary variable
    }
  }, {
    key: "create_airport_maps_and_codes",
    value: function create_airport_maps_and_codes() {
      var airport_map_icao = {};
      var airport_map_iata = {};
      var airport_codes_icao = [];
      var airport_codes_iata = []; // create airport map and codes

      var _iterator = _createForOfIteratorHelper(afm.airports),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var airport = _step.value;
          var icao_key = airport.icao;
          var iata_key = airport.iata;
          airport_map_icao[icao_key] = airport;
          airport_codes_icao.push({
            label: "".concat(icao_key, ": ").concat(airport.name),
            value: icao_key
          });
          airport_map_iata[iata_key] = airport;
          airport_codes_iata.push({
            label: "".concat(iata_key, ": ").concat(airport.name),
            value: iata_key
          });
        } // sort airport codes alphabetically

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var comparator = function comparator(a, b) {
        return afm.UtilitiesCS.compare_strings(a.label, b.label);
      };

      airport_codes_icao.sort(comparator);
      airport_codes_iata.sort(comparator); // assign to app namespace

      afm.airport_map_icao = airport_map_icao;
      afm.airport_map_iata = airport_map_iata;
      afm.airport_codes_icao = airport_codes_icao;
      afm.airport_codes_iata = airport_codes_iata;
    }
  }]);

  return AirportProcessor;
}();
/* global afm $ alert */
// sends async requests to the afm server


afm.AsyncRequester = /*#__PURE__*/function () {
  function AsyncRequester() {
    _classCallCheck(this, AsyncRequester);
  }

  _createClass(AsyncRequester, [{
    key: "success",
    // when the request succeeds, call callback(null, response)
    value: function success(callback) {
      if (callback == null) {
        callback = function callback() {};
      }

      return function (res) {
        callback(null, res);
      };
    } // when the request fails, alert the user and call callback(err)

  }, {
    key: "error",
    value: function error(callback) {
      if (callback == null) {
        callback = function callback() {};
      }

      return function (jqXHR, text_status, err) {
        alert("There was an error: ".concat(JSON.stringify(jqXHR), ", ").concat(text_status, ", ").concat(err));
        callback(err);
      };
    } // request send fatigue data to PRISM

  }, {
    key: "send_to_prism",
    value: function send_to_prism(schedule_id, callback) {
      $.ajax({
        dataType: 'json',
        type: 'POST',
        url: "/prism/send_scores/".concat(schedule_id),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // updates a company's logo

  }, {
    key: "update_company_logo",
    value: function update_company_logo(company_id, data, callback) {
      $.ajax({
        data: data,
        contentType: false,
        cache: false,
        processData: false,
        type: 'PUT',
        url: "/admin/companies/".concat(company_id, "/logo"),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // logs an administrator in as a user

  }, {
    key: "user_login",
    value: function user_login(email, callback) {
      $.ajax({
        dataType: 'json',
        type: 'POST',
        url: "/admin/user_login/".concat(email),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // enables admin to delete the user's saved data

  }, {
    key: "user_delete_data",
    value: function user_delete_data(user_id, callback) {
      $.ajax({
        dataType: 'json',
        type: 'DELETE',
        url: "/admin/users/".concat(user_id, "/data"),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // gets an fi_data_set's schedules and statistics

  }, {
    key: "get_schedules_and_statistics",
    value: function get_schedules_and_statistics(id, callback) {
      $.ajax({
        dataType: 'json',
        url: "/fi_data_sets/".concat(id, "/schedules_and_statistics"),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // gets an fi_data_set's errors and warnings

  }, {
    key: "get_errors_and_warnings",
    value: function get_errors_and_warnings(id, callback) {
      $.ajax({
        dataType: 'json',
        url: "/fi_data_sets/".concat(id, "/errors_and_warnings"),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // returns information about the user's fi data config

  }, {
    key: "get_fi_data_config",
    value: function get_fi_data_config(callback) {
      $.ajax({
        dataType: 'json',
        url: '/fi_data_sets/get_fi_data_config',
        success: this.success(callback),
        error: this.error(callback)
      });
    } // updates the fi_data_set sort order

  }, {
    key: "update_fi_data_set_sort_orders",
    value: function update_fi_data_set_sort_orders(data, callback) {
      $.ajax({
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        type: 'PUT',
        url: '/fi_data_sets/sort_orders',
        success: this.success(callback),
        error: this.error(callback)
      });
    } // downloads a .pdf report

  }, {
    key: "download_pdf_report",
    value: function download_pdf_report(id, callback) {
      $.ajax({
        contentType: false,
        processData: false,
        xhrFields: {
          responseType: 'blob'
        },
        url: "/pdf_reports/".concat(id, "/download"),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // updates the fi_data_set fi_worksheet sort order

  }, {
    key: "update_fi_worksheets_sort_orders",
    value: function update_fi_worksheets_sort_orders(fi_data_set_id, data, callback) {
      $.ajax({
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        type: 'PUT',
        url: "/fi_data_sets/".concat(fi_data_set_id, "/fi_worksheets/sort_orders"),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // updates the user's fi_schedule sort order

  }, {
    key: "update_fi_schedules_sort_orders",
    value: function update_fi_schedules_sort_orders(fi_data_set_id, data, callback) {
      $.ajax({
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        type: 'PUT',
        url: "/fi_data_sets/".concat(fi_data_set_id, "/fi_schedules/sort_orders"),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // updates the user's fi_metric_report sort order

  }, {
    key: "update_fi_metric_reports_sort_orders",
    value: function update_fi_metric_reports_sort_orders(fi_data_set_id, data, callback) {
      $.ajax({
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        type: 'PUT',
        url: "/fi_data_sets/".concat(fi_data_set_id, "/fi_metric_reports/sort_orders"),
        success: this.success(callback),
        error: this.error(callback)
      });
    } // gets the user's tracked sleep

  }, {
    key: "get_tracked_sleep",
    value: function get_tracked_sleep(data, callback) {
      $.ajax({
        data: data,
        dataType: 'json',
        url: '/tracked_sleep',
        success: this.success(callback),
        error: this.error(callback)
      });
    }
  }, {
    key: "get_screenshot_data_set",
    value: function get_screenshot_data_set(id, callback) {
      $.ajax({
        dataType: 'json',
        url: "/screenshot/screenshot_data_set/".concat(id),
        success: function success(result) {
          return callback(null, result);
        },
        error: function error(jqXHR) {
          callback(JSON.stringify(jqXHR, null, '\t'));
        }
      });
    }
  }]);

  return AsyncRequester;
}();
/* global afm Backbone alert d3 _ */
// All the Backbone data model classes and instances


var DataStore = afm.DataStore = /*#__PURE__*/function () {
  function DataStore() {
    _classCallCheck(this, DataStore);
  }

  _createClass(DataStore, null, [{
    key: "initClass",
    value: function initClass() {
      this.data = {};
      this.models = {};
    }
  }, {
    key: "initialize",
    value: function initialize(callback) {
      this.define_models();
      afm.AirportProcessor.initialize(); // load the user's preferences

      this.data.preferences.fetch({
        success: function success() {
          // additional initializations
          afm.Tracker.initialize();
          callback();
        }
      });
    }
  }, {
    key: "define_models",
    value: function define_models() {
      var _this2 = this;

      //
      // base model functionality - for inheritance by other models
      //
      var BaseModel = Backbone.Model.extend({
        idAttribute: '_id',
        initialize: function initialize() {
          var _this = this;

          // is_dirty tracking
          this.is_dirty = false;
          this.on('change', function () {
            _this.is_dirty = true;
          });
          this.on('sync', function () {
            _this.is_dirty = false;
          }); // is_destroyed tracking

          this.is_destroyed = false;
          this.on('destroy', function () {
            _this.is_destroyed = true;
          }); // pop up an alert for all AJAX errors

          this.on('error', function (model, error) {
            return alert(JSON.stringify(error));
          });
        },
        friendly_last_modified: function friendly_last_modified() {
          var include_description = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

          if (!this.get('last_modified')) {
            return '';
          }

          var to_return = include_description ? 'Last modified: ' : '';
          return to_return + d3.timeFormat('%Y-%m-%d&nbsp;&nbsp;&nbsp;%H:%M')(this.get('last_modified'));
        },
        created_at_str: function created_at_str() {
          if (!this.get('created_at')) {
            return '';
          }

          return 'created: ' + d3.timeFormat('%d %b %Y at %H:%M %p')(new Date(this.get('created_at')));
        },
        is_own: function is_own() {
          var user = this.get('user');
          return !user || user._id === afm.DataStore.data.preferences.get('user');
        }
      });
      var BaseCollection = Backbone.Collection.extend(); //
      // user's preferences
      //

      var Preferences = BaseModel.extend({
        url: function url() {
          return '/user_preferences';
        },
        parse: function parse(response) {
          // deserialize the custom airports
          response.custom_airports = _this2.deserialize_custom_airports(response.custom_airports);
          return response;
        }
      });
      this.data.preferences = new Preferences(); //
      // user's FM schedules
      //

      var Schedule = BaseModel.extend({
        initialize: function initialize() {
          var _this3 = this;

          Schedule.__super__.initialize.apply(this);

          this.on('sync', function () {
            _this3.cached_date_range = null;
          });
        },
        // returns the UTC date range of the schedule's data
        date_range: function date_range() {
          if (this.cached_date_range != null) {
            return this.cached_date_range;
          }

          var s = this.deserialize();

          if (s.data.start_date == null) {
            return null;
          }

          var start_date = s.data.start_date;
          var end_date = start_date + s.get_time_span().end_time * 3600 * 1000;

          if (isNaN(end_date)) {
            end_date = start_date;
          }

          this.cached_date_range = {
            start_date: start_date,
            end_date: end_date
          };
          return this.cached_date_range;
        },
        // returns a date range string,
        // falling back to the start date string if necessary
        date_range_string: function date_range_string() {
          var _this$get;

          var include_description = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          var view = (_this$get = this.get('timeline_settings')) === null || _this$get === void 0 ? void 0 : _this$get.view;
          var start_date_str = this.get('start_date');
          var homebase = afm.LocationHelper.is_airport_code_valid(this.get('homebase'), this.get('homebase_type'));

          if (!view || !homebase) {
            var _str = afm.UtilitiesTime.format_date_range(new Date(start_date_str));

            return include_description ? "Start date: ".concat(_str) : _str;
          }

          var start_date = afm.UtilitiesTime.convert_date_string_to_date(start_date_str);
          var date_1 = afm.UtilitiesTime.convert_time_to_local_date_time_strings(start_date, view.start_time, homebase).date;
          var date_2 = afm.UtilitiesTime.convert_time_to_local_date_time_strings(start_date, view.end_time, homebase).date;
          var str = afm.UtilitiesTime.format_date_range(new Date(date_1), new Date(date_2));
          return include_description ? "Date range: ".concat(str) : str;
        },
        // returns a new deserialized afm.Schedule object
        deserialize: function deserialize() {
          var schedule = new afm.Schedule(afm.DataStore.data.preferences.toJSON());
          schedule.deserialize(this.toJSON());
          return schedule;
        }
      });
      var Schedules = BaseCollection.extend({
        url: '/schedules',
        model: Schedule
      });
      this.data.schedules = new Schedules(); //
      // ScheduleTemplates
      //

      var ScheduleTemplate = BaseModel.extend({
        parse: function parse(response) {
          // add a default user object if there is none
          if (!response.user) {
            response.user = {
              first_name: 'Pulsar',
              last_name: 'Informatics'
            };
          }

          return response;
        },
        visible_to_collaborators: function visible_to_collaborators() {
          return true;
        }
      });
      var ScheduleTemplates = BaseCollection.extend({
        url: '/schedule_templates',
        model: ScheduleTemplate
      });
      this.models.ScheduleTemplate = ScheduleTemplate;
      this.data.schedule_templates = new ScheduleTemplates(); //
      // user's FI data set children
      //

      var FIWorksheet = BaseModel.extend({
        parse: function parse(response) {
          // add a default user object if there is none
          if (!response.user) {
            response.user = {
              first_name: 'Pulsar',
              last_name: 'Informatics'
            };
          }

          return response;
        },
        visible_to_collaborators: function visible_to_collaborators() {
          return this.get('visible_to_collaborators');
        }
      });
      var FIWorksheets = BaseCollection.extend({
        model: FIWorksheet
      });
      var FISchedule = Schedule.extend({
        parse: function parse(response) {
          response.stats = _this2.create_schedule_stats(response);
          return response;
        },
        visible_to_collaborators: function visible_to_collaborators() {
          return this.get('visible_to_collaborators');
        },
        // returns a date range string,
        // falling back to the start date string if necessary
        date_range_string: function date_range_string() {
          var _this$get2;

          var include_description = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          var start_date_str = this.get('start_date');
          var view = (_this$get2 = this.get('timeline_settings')) === null || _this$get2 === void 0 ? void 0 : _this$get2.view;
          var homebase = afm.LocationHelper.is_airport_code_valid(this.get('homebase'), this.get('homebase_type'));

          if (!view || !homebase) {
            var str = afm.UtilitiesTime.format_date_range(new Date(start_date_str));
            return include_description ? "Start date: ".concat(str) : str;
          }

          var start_date = afm.UtilitiesTime.convert_date_string_to_date(start_date_str);
          var date_1 = afm.UtilitiesTime.convert_time_to_local_date_time_strings(start_date, view.start_time, homebase).date;
          var date_2 = afm.UtilitiesTime.convert_time_to_local_date_time_strings(start_date, view.end_time, homebase).date;
          var date_str = afm.UtilitiesTime.format_date_range(new Date(date_1), new Date(date_2));
          return include_description ? "Date range: ".concat(date_str) : date_str;
        }
      });
      var FISchedules = BaseCollection.extend({
        model: FISchedule
      }); //
      // FIMetricReport
      //

      var FIMetricReport = BaseModel.extend({
        parse: function parse(response) {
          // add a default user object if there is none
          if (!response.user) {
            response.user = {
              first_name: 'Pulsar',
              last_name: 'Informatics'
            };
          }

          return response;
        },
        visible_to_collaborators: function visible_to_collaborators() {
          return this.get('visible_to_collaborators');
        }
      });
      var FIMetricReports = BaseCollection.extend({
        model: FIMetricReport
      });
      var FICollaboration = BaseModel.extend({
        url: function url() {
          return "/fi_data_sets/".concat(this.owner.id, "/collaboration");
        },
        isNew: function isNew() {
          return false;
        }
      }); // so that PUT and DELETE requests are sent to server
      //
      // user's FI data sets
      //

      var FIDataSet = BaseModel.extend({
        initialize: function initialize() {
          FIDataSet.__super__.initialize.apply(this);

          this.collaboration = new FICollaboration();
          this.collaboration.owner = this; // convenience properties to track the object's current
          // filter and pagination state

          this.is_filtered = false;
          this.is_paginated = false;
          this.fleet_analysis = null;
        },
        is_loading: function is_loading() {
          var progress = this.get('progress');
          var errors_count = this.get('errors_count');
          var stats = this.get('stats');
          return (progress !== 1 || stats && stats.progress !== 1) && (!errors_count || errors_count === 0);
        },
        has_errors: function has_errors() {
          return this.get('errors_count') > 0;
        },
        has_worksheets: function has_worksheets() {
          var _this$fi_worksheets;

          return ((_this$fi_worksheets = this.fi_worksheets) === null || _this$fi_worksheets === void 0 ? void 0 : _this$fi_worksheets.models.length) > 0;
        },
        has_schedules: function has_schedules() {
          var _this$fi_schedules;

          return ((_this$fi_schedules = this.fi_schedules) === null || _this$fi_schedules === void 0 ? void 0 : _this$fi_schedules.models.length) > 0;
        },
        has_metric_reports: function has_metric_reports() {
          var _this$fi_metric_repor;

          return ((_this$fi_metric_repor = this.fi_metric_reports) === null || _this$fi_metric_repor === void 0 ? void 0 : _this$fi_metric_repor.models.length) > 0;
        },
        has_collaborators: function has_collaborators() {
          var collaborators = this.get('collaborators');
          return collaborators && collaborators.length > 0;
        },
        visible_to_collaborators: function visible_to_collaborators() {
          return true;
        },
        date_range_string: function date_range_string() {
          var include_description = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          var stats = this.get('stats');

          if (!stats) {
            return '';
          }

          var str = afm.UtilitiesTime.format_date_range(new Date(stats.start_date), new Date(stats.end_date));
          return include_description ? "Date range: ".concat(str) : str;
        },
        parse: function parse(response) {
          var _this4 = this;

          if (response.fi_worksheets || !this.fi_worksheets) {
            this.fi_worksheets = new FIWorksheets(response.fi_worksheets, {
              parse: true
            });

            this.fi_worksheets.url = function () {
              return "/fi_data_sets/".concat(_this4.id, "/fi_worksheets");
            };

            this.fi_worksheets.comparator = 'sort_order';
          }

          if (response.fi_metric_reports || !this.fi_metric_reports) {
            this.fi_metric_reports = new FIMetricReports(response.fi_metric_reports, {
              parse: true
            });

            this.fi_metric_reports.url = function () {
              return "/fi_data_sets/".concat(_this4.id, "/fi_metric_reports");
            };

            this.fi_metric_reports.comparator = 'sort_order';
          }

          if (response.fi_schedules || !this.fi_schedules) {
            this.fi_schedules = new FISchedules(response.fi_schedules, {
              parse: true
            });

            this.fi_schedules.url = function () {
              return "/fi_data_sets/".concat(_this4.id, "/fi_schedules");
            };

            this.fi_schedules.comparator = 'sort_order';
          }

          return _.omit(response, ['fi_schedules', 'fi_worksheets', 'fi_metric_reports']);
        }
      });
      var FIDataSets = BaseCollection.extend({
        url: '/fi_data_sets',
        model: FIDataSet
      });
      this.models.FISchedule = FISchedule;
      this.models.FIWorksheet = FIWorksheet;
      this.models.FIDataSet = FIDataSet;
      this.models.FIMetricReport = FIMetricReport;
      this.data.fi_data_set_models = new FIDataSets(); //
      // FIWorksheetTemplates
      //

      var FIWorksheetTemplate = BaseModel.extend({
        parse: function parse(response) {
          // add a default user object if there is none
          if (!response.user) {
            response.user = {
              first_name: 'Pulsar',
              last_name: 'Informatics'
            };
          }

          return response;
        },
        visible_to_collaborators: function visible_to_collaborators() {
          return true;
        },
        // toggles the worksheet favorite status
        toggle_favorite: function toggle_favorite() {
          var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var options = {
            url: "/fi_worksheet_templates/".concat(this.id, "/toggle_favorite"),
            type: 'PUT'
          };

          _.extend(options, opts);

          return this.save(null, options);
        }
      });
      var FIWorksheetTemplates = BaseCollection.extend({
        url: '/fi_worksheet_templates',
        model: FIWorksheetTemplate
      });
      this.models.FIWorksheetTemplate = FIWorksheetTemplate;
      this.data.fi_worksheet_templates = new FIWorksheetTemplates(); //
      // FIMetricReportTemplates
      //

      var FIMetricReportTemplate = BaseModel.extend({
        parse: function parse(response) {
          // add a default user object if there is none
          if (!response.user) {
            response.user = {
              first_name: 'Pulsar',
              last_name: 'Informatics'
            };
          }

          return response;
        },
        visible_to_collaborators: function visible_to_collaborators() {
          return true;
        }
      });
      var FIMetricReportTemplates = BaseCollection.extend({
        url: '/fi_metric_report_templates',
        model: FIMetricReportTemplate
      });
      this.models.FIMetricReportTemplate = FIMetricReportTemplate;
      this.data.fi_metric_report_templates = new FIMetricReportTemplates(); //
      // PDF Reports
      //

      var PDFReport = BaseModel.extend({
        friendly_name: function friendly_name() {
          var name = afm.UtilitiesCS.filename_safe_string(afm.UtilitiesCS.encode_html(this.get('name') || 'Untitled analysis'));
          var date = d3.timeFormat('%Y_%m_%d_%H%M%S')(new Date(this.get('created_at')));
          return "".concat(name, "_").concat(date, ".pdf");
        },
        friendly_status: function friendly_status() {
          if (!this.get('status') || !this.get('last_modified')) {
            return 'Unknown';
          }

          if (this.get('status') === 'completed') {
            var date_str = d3.timeFormat('%Y-%m-%d')(this.get('last_modified') + 7 * 24 * 3600 * 1000);
            return "Ready for download. Available until ".concat(date_str, ".");
          }

          if (this.get('status') === 'error') {
            return 'There was an error preparing the report; please try again.';
          }

          return "".concat(afm.UtilitiesCS.capitalize(this.get('status')), "...");
        },
        is_processing: function is_processing() {
          return !['completed', 'error'].includes(this.get('status'));
        }
      });
      var PDFReports = BaseCollection.extend({
        url: '/pdf_reports',
        model: PDFReport
      });
      this.models.PDFReport = PDFReport;
      this.data.pdf_reports = new PDFReports(); //
      // admin - users
      //

      var User = BaseModel.extend({
        fi_data_loader_configs: function fi_data_loader_configs() {
          var configs = this.get('fi_data_loader_config');

          if (!configs) {
            return [];
          }

          if (!Array.isArray(configs)) {
            return [configs];
          }

          return configs;
        },
        initialize: function initialize() {
          var _this5 = this;

          User.__super__.initialize.apply(this);

          this.schedules = new Schedules();
          this.preferences = new Preferences();

          this.preferences.url = function () {
            return "/admin/users/".concat(_this5.id, "/preferences");
          };

          this.schedules.url = function () {
            return "/admin/users/".concat(_this5.id, "/schedules");
          };
        }
      });
      var Users = BaseCollection.extend({
        url: '/admin/users',
        model: User
      });
      this.data.users = new Users();
      this.data.users.comparator = 'email'; //
      // admin - companies
      //

      var Company = BaseModel.extend();
      var Companies = BaseCollection.extend({
        url: '/admin/companies',
        model: Company
      });
      this.data.companies = new Companies();

      this.data.companies.comparator = function (a, b) {
        if (a.get('key') === 'prism_frat') {
          return 1;
        }

        if (b.get('key') === 'prism_frat') {
          return -1;
        }

        return afm.UtilitiesCS.compare_strings(a.get('key'), b.get('key'));
      }; //
      // admin - FI data loader configs
      //


      var FIDataLoaderConfig = BaseModel.extend();
      var FIDataLoaderConfigs = BaseCollection.extend({
        url: '/admin/fi_data_loader_configs',
        model: FIDataLoaderConfig
      });
      this.data.fi_data_loader_configs = new FIDataLoaderConfigs();
    }
  }, {
    key: "deserialize_custom_airports",
    value: function deserialize_custom_airports(custom_airports) {
      var to_return = [];

      if (!custom_airports || !custom_airports.length) {
        return;
      }

      var _iterator2 = _createForOfIteratorHelper(custom_airports),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var a = _step2.value;

          var nearest_airport_type = function () {
            switch (a.nearest_airport_type) {
              case 'iata':
                return 'iata';

              default:
                return 'icao';
            }
          }();

          var nearest_airport = function () {
            switch (nearest_airport_type) {
              case 'iata':
                return afm.airport_map_iata[a.nearest_airport];

              default:
                return afm.airport_map_icao[a.nearest_airport];
            }
          }();

          if (nearest_airport == null) {
            continue;
          }

          to_return.push(afm.LocationHelper.create_custom_airport(a.custom_name, a.custom_abbr, nearest_airport, nearest_airport_type));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return to_return;
    } // Schedules store statistics differently than fi_worksheets and fi_data_sets.
    // This function maps schedule metrics to an equivalent statistics object

  }, {
    key: "create_schedule_stats",
    value: function create_schedule_stats(response) {
      var _response$metrics, _response$metrics$fin, _response$metrics$fin2;

      var trips_count = ((_response$metrics = response.metrics) === null || _response$metrics === void 0 ? void 0 : (_response$metrics$fin = _response$metrics.find(function (obj) {
        return obj.key === 'max_fatigue_for_flights';
      })) === null || _response$metrics$fin === void 0 ? void 0 : (_response$metrics$fin2 = _response$metrics$fin.value) === null || _response$metrics$fin2 === void 0 ? void 0 : _response$metrics$fin2.length) || 0;
      var stats = {
        trips_count: trips_count,
        schedules_count: 1,
        alerts_count: []
      };

      for (var _i = 0, _Array$from = Array.from(response.metrics); _i < _Array$from.length; _i++) {
        var metric = _Array$from[_i];
        var key = metric.key,
            value = metric.value;

        if (afm.AlertRules.keys().includes(key)) {
          var count = 0;

          for (var k in value) {
            var v = value[k];
            count += v;
          }

          stats.alerts_count.push({
            key: key,
            count: count
          });
        }

        if (key === 'avg_duty_fatigue' && stats.avg_fatigue == null) {
          stats.avg_fatigue = value;
        }

        if (key === 'avg_flight_fatigue' && trips_count > 0) {
          stats.avg_fatigue = value;
        }

        if (key === 'max_duty_fatigue' && trips_count === 0) {
          stats.fatigue_quantiles = [NaN, NaN, NaN, NaN, NaN, NaN, value];
        }

        if (key === 'max_flight_fatigue' && trips_count > 0 && stats.fatigue_quantiles == null) {
          stats.fatigue_quantiles = [NaN, NaN, NaN, NaN, NaN, NaN, value];
        }

        if (key === 'max_tod_fatigue' && trips_count > 0) {
          stats.fatigue_quantiles = [NaN, NaN, NaN, NaN, NaN, NaN, value];
        }
      }

      return stats;
    }
  }]);

  return DataStore;
}();

DataStore.initClass();
/* global afm */
// ICAO regions, taken from
// https://en.wikipedia.org/wiki/International_Civil_Aviation_Organization_airport_code

afm.ICAORegions = /*#__PURE__*/function () {
  function ICAORegions() {
    _classCallCheck(this, ICAORegions);
  }

  _createClass(ICAORegions, null, [{
    key: "get_regions",
    // Returns an array of all the region objects
    value: function get_regions() {
      return [{
        id: 'A',
        description: 'Western South Pacific'
      }, {
        id: 'B',
        description: 'Greenland, Iceland, Kosovo'
      }, {
        id: 'C',
        description: 'Canada'
      }, {
        id: 'D',
        description: 'Eastern West Africa'
      }, {
        id: 'E',
        description: 'Northern Europe'
      }, {
        id: 'F',
        description: 'Central & Southern Africa, Indian Ocean'
      }, {
        id: 'G',
        description: 'Western West Africa'
      }, {
        id: 'H',
        description: 'East & Northeast Africa'
      }, {
        id: 'K',
        description: 'Contiguous United States'
      }, {
        id: 'L',
        description: 'Southern Europe, Israel, Turkey'
      }, {
        id: 'M',
        description: 'Central America, Mexico, Northern & Western Caribbean'
      }, {
        id: 'N',
        description: 'South Pacific'
      }, {
        id: 'O',
        description: 'Pakistan, Afghanistan, Western Asia'
      }, {
        id: 'P',
        description: 'Eastern North Pacific'
      }, {
        id: 'R',
        description: 'China, Korea, Philippines, Japan'
      }, {
        id: 'S',
        description: 'South America'
      }, {
        id: 'T',
        description: 'Eastern & Southern Caribbean'
      }, {
        id: 'U',
        description: 'Russia, Post-Soviet States'
      }, {
        id: 'V',
        description: 'South & Mainland Southeast Asia'
      }, {
        id: 'W',
        description: 'Maritime Southeast Asia'
      }, {
        id: 'Y',
        description: 'Australia'
      }, {
        id: 'Z',
        description: 'East Asia'
      }];
    } // Returns an array of all the region ids

  }, {
    key: "get_region_ids",
    value: function get_region_ids() {
      return this.get_regions().map(function (region) {
        return region.id;
      });
    } // Returns an array of all the region ids that don't appear in the
    // input arrray of ids

  }, {
    key: "get_complement_ids",
    value: function get_complement_ids(ids) {
      var regions = this.get_region_ids();

      if (!((ids != null ? ids.length : undefined) > 0)) {
        return regions;
      }

      var _iterator3 = _createForOfIteratorHelper(ids),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var id = _step3.value;
          var index = regions.indexOf(id);

          if (index === -1) {
            continue;
          }

          regions.splice(index, 1);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return regions;
    } // Returns an array of regions associated with the United States

  }, {
    key: "get_us_region_ids",
    value: function get_us_region_ids() {
      return ['K', 'P'];
    } // Returns an array of regions not associated with the United States

  }, {
    key: "get_non_us_region_ids",
    value: function get_non_us_region_ids() {
      return this.get_complement_ids(this.get_us_region_ids());
    }
  }]);

  return ICAORegions;
}();
/* global afm */
// Convenience methods commonly used on location data


afm.LocationHelper = /*#__PURE__*/function () {
  function LocationHelper() {
    _classCallCheck(this, LocationHelper);
  }

  _createClass(LocationHelper, null, [{
    key: "find_location_at_time",
    value: function find_location_at_time(start_location, intervals, time) {
      var closest_time = Number.NEGATIVE_INFINITY;
      var location = start_location;

      for (var _i2 = 0, _Array$from2 = Array.from(intervals); _i2 < _Array$from2.length; _i2++) {
        var interval = _Array$from2[_i2];

        if (interval.start_time <= time && interval.start_time > closest_time && interval.origin) {
          location = interval.origin;
          closest_time = interval.start_time;
        }

        if (interval.end_time <= time && interval.end_time > closest_time && interval.destination) {
          location = interval.destination;
          closest_time = interval.end_time;
        }
      }

      return location;
    }
  }, {
    key: "find_first_location_after_time",
    value: function find_first_location_after_time(intervals, time) {
      var closest_time = Number.POSITIVE_INFINITY;
      var location = null;

      for (var _i3 = 0, _Array$from3 = Array.from(intervals); _i3 < _Array$from3.length; _i3++) {
        var interval = _Array$from3[_i3];

        if (interval.start_time >= time && interval.start_time < closest_time && interval.origin) {
          location = interval.origin;
          closest_time = interval.start_time;
        }

        if (interval.end_time >= time && interval.end_time < closest_time && interval.destination) {
          location = interval.destination;
          closest_time = interval.end_time;
        }
      }

      return location;
    } // checks to see if an airport code represents a known airport
    // returns the airport if valid, otherwise null

  }, {
    key: "is_airport_code_valid",
    value: function is_airport_code_valid(airport_string, type, custom_airports) {
      if (type == null) {
        type = 'icao';
      }

      if (airport_string == null || typeof airport_string !== 'string' || !(airport_string.length > 0)) {
        return null;
      }

      var str = airport_string.toUpperCase();

      if (type === 'custom' && (custom_airports != null ? custom_airports.length : undefined) > 0) {
        var custom_codes = custom_airports.map(function (a) {
          return a.custom_name;
        });
        var ind = custom_codes.indexOf(airport_string);
        var custom_airport = custom_airports[ind];
        return afm.LocationHelper.deserialize_custom_airport(custom_airport);
      } else if (type === 'icao' && afm.airport_map_icao[str]) {
        return afm.airport_map_icao[str];
      } else if (type === 'iata' && afm.airport_map_iata[str]) {
        return afm.airport_map_iata[str];
      } else {
        return null;
      }
    } // deserializes a custom airport so that it has all the properties
    // of an actual airport

  }, {
    key: "deserialize_custom_airport",
    value: function deserialize_custom_airport(custom_airport) {
      if (custom_airport == null || custom_airport.custom_name == null || custom_airport.custom_abbr == null || custom_airport.nearest_airport == null || custom_airport.nearest_airport_type == null) {
        return null;
      }

      var map = custom_airport.nearest_airport_type === 'iata' ? afm.airport_map_iata : afm.airport_map_icao;

      if (map[custom_airport.nearest_airport] == null) {
        return null;
      }

      return afm.LocationHelper.create_custom_airport(custom_airport.custom_name, custom_airport.custom_abbr, map[custom_airport.nearest_airport], custom_airport.nearest_airport_type);
    } // creates a custom airport

  }, {
    key: "create_custom_airport",
    value: function create_custom_airport(name, abbr, nearest_airport, nearest_airport_type) {
      var airport = {
        is_custom: true,
        custom_name: name,
        custom_abbr: abbr,
        nearest_airport: nearest_airport_type === 'iata' ? nearest_airport.iata : nearest_airport.icao,
        nearest_airport_type: nearest_airport_type === 'iata' ? 'iata' : 'icao'
      };

      for (var k in nearest_airport) {
        var v = nearest_airport[k];
        airport[k] = v;
      }

      return airport;
    } // returns the appropriate airport abbreviation based on the preferred
    // airport type

  }, {
    key: "get_airport_abbr",
    value: function get_airport_abbr(airport, preferred_airport_type) {
      if (airport == null) {
        return null;
      }

      if (airport.is_custom) {
        return airport.custom_abbr;
      }

      if (preferred_airport_type === 'iata') {
        return airport.iata;
      } else {
        return airport.icao;
      }
    }
  }, {
    key: "convert_intervals_to_sorted_location_sequence",
    value: function convert_intervals_to_sorted_location_sequence(intervals, end_time) {
      var seq = [];

      if (!((intervals != null ? intervals.length : undefined) > 0) || end_time == null) {
        return seq;
      }

      for (var _i4 = 0, _Array$from4 = Array.from(intervals); _i4 < _Array$from4.length; _i4++) {
        var interval = _Array$from4[_i4];

        if (interval.start_time <= end_time) {
          seq.push({
            time: interval.start_time,
            duration: interval.end_time - interval.start_time,
            airport: interval.origin,
            type: interval.type,
            metadata: interval.metadata,
            endpoint_type: 'left'
          });
        }

        if (interval.type === 'flight' && interval.end_time - interval.start_time > 0.25) {
          // top of climb
          seq.push({
            time: interval.start_time + 0.25,
            duration: interval.end_time - interval.start_time,
            airport: interval.origin,
            type: 'flight_toc',
            metadata: interval.metadata,
            endpoint_type: 'right'
          }); // top of descent

          seq.push({
            time: interval.end_time - 0.25,
            duration: interval.end_time - interval.start_time,
            airport: interval.destination,
            type: 'flight_tod',
            metadata: interval.metadata,
            endpoint_type: 'left'
          });
        }

        if (interval.end_time <= end_time) {
          seq.push({
            time: interval.end_time,
            duration: interval.end_time - interval.start_time,
            airport: interval.destination,
            type: interval.type,
            metadata: interval.metadata,
            endpoint_type: 'right'
          });
        }
      } // sort by event time, or in the case the event times are equal,
      // which interval came first


      var comparator = function comparator(a, b) {
        switch (false) {
          case a.time === b.time:
            return a.time - b.time;

          case a.endpoint_type !== 'right' || b.endpoint_type !== 'left':
            return -1;

          case a.endpoint_type !== 'left' || b.endpoint_type !== 'right':
            return 1;

          default:
            return 0;
        }
      };

      seq.sort(comparator);
      return seq;
    }
  }]);

  return LocationHelper;
}();
/* global afm */

/* eslint max-len: 0 */
// Convenience methods commonly used on schedule data


afm.ScheduleHelper = /*#__PURE__*/function () {
  function ScheduleHelper() {
    _classCallCheck(this, ScheduleHelper);
  }

  _createClass(ScheduleHelper, null, [{
    key: "is_in_flight_at_time",
    value: function is_in_flight_at_time(intervals, time) {
      if (!((intervals != null ? intervals.length : undefined) > 0)) {
        return false;
      }

      return intervals.reduce(function (prev, curr) {
        return prev || curr.type === 'flight' && curr.start_time <= time && curr.end_time >= time;
      }, false);
    }
  }, {
    key: "find_flights_in_duty",
    value: function find_flights_in_duty(duty, flights) {
      if (duty == null || !((flights != null ? flights.length : undefined) > 0)) {
        return [];
      }

      return Array.from(flights).filter(function (f) {
        return f.type === 'flight' && f.start_time >= duty.start_time && f.end_time <= duty.end_time;
      });
    } // Returns the one duty that contains the flight (if there is one)

  }, {
    key: "find_duty_for_flight",
    value: function find_duty_for_flight(duties, flight) {
      if (flight == null || !((duties != null ? duties.length : undefined) > 0)) {
        return null;
      }

      for (var _i5 = 0, _Array$from5 = Array.from(duties); _i5 < _Array$from5.length; _i5++) {
        var duty = _Array$from5[_i5];

        if (duty.type === 'duty') {
          if (duty.start_time <= flight.start_time && duty.end_time >= flight.end_time) {
            return duty;
          }
        }
      }

      return null;
    } // Returns array of all duties that intersect an interval (if there are any)
    // This is useful for finding duties that have been split

  }, {
    key: "find_duties_for_interval",
    value: function find_duties_for_interval(duties, interval) {
      if (!interval || !Array.isArray(duties) || !((duties === null || duties === void 0 ? void 0 : duties.length) > 0)) {
        return [];
      }

      return duties.filter(function (d) {
        return d.type === 'duty' && afm.UtilitiesTime.intervals_intersect(d, interval);
      });
    } // Use to insert in-flight rest for a single crewmember's schedule.
    // For flights that have the is_augmented flag set to true or a number, this
    // splits the containing duty, allocating a fraction of the time as available
    // rest time.
    // Returns the array of new duties

  }, {
    key: "insert_in_flight_rest",
    value: function insert_in_flight_rest(duties, flights) {
      if (!((duties != null ? duties.length : undefined) > 0)) {
        return [];
      }

      var new_duties = duties.slice();

      if (!((flights != null ? flights.length : undefined) > 0)) {
        return new_duties;
      }

      for (var _i6 = 0, _Array$from6 = Array.from(flights); _i6 < _Array$from6.length; _i6++) {
        var flight = _Array$from6[_i6];

        if (flight.is_augmented) {
          var duty = afm.ScheduleHelper.find_duty_for_flight(new_duties, flight);

          if (duty == null) {
            continue;
          } // augmented crew is 3 unless specified otherwise


          var pilot_count = parseFloat(flight.is_augmented) || 3; // assume middle (pilot_count-2)/pilot_count of flight is rest opportunity

          var t_total = (flight.end_time - flight.start_time) * (pilot_count - 2) / pilot_count; // don't split if the rest opportunity is less than 1/2 hour

          if (t_total < 0.5) {
            continue;
          }

          var split_duties = afm.ScheduleHelper.split_duty(duty, duty.origin, duty.origin, flight.start_time + t_total, flight.end_time - t_total, t_total); // remove the old duty and add the split duties

          new_duties.splice.apply(new_duties, [new_duties.indexOf(duty), 1].concat(_toConsumableArray(Array.from(split_duties))));
        }
      }

      return new_duties;
    } // Performs the splitting of a duty into two duties, where
    // t_0 and t_1 being the earliest and latest time to split the duty
    // t_total is total rest time to be inserted, if null assumed to be t_1 - t_0
    // Returns two duties.

  }, {
    key: "split_duty",
    value: function split_duty(duty, destination, origin, t_0, t_1, t_total) {
      if (!t_total) {
        t_total = t_1 - t_0;
      }

      var end_time = t_0 + (t_1 - t_0 - t_total) / 2;
      var start_time = end_time + t_total;
      return [{
        type: 'duty',
        origin: duty.origin,
        start_time: duty.start_time,
        destination: destination,
        end_time: end_time,
        metadata: _objectSpread({}, duty.metadata)
      }, {
        type: 'duty',
        origin: origin,
        start_time: start_time,
        destination: duty.destination,
        end_time: duty.end_time,
        metadata: _objectSpread({}, duty.metadata)
      }];
    } // Calculates the total duration of all the intervals

  }, {
    key: "calculate_total_duration",
    value: function calculate_total_duration(intervals) {
      if (!((intervals != null ? intervals.length : undefined) > 0)) {
        return 0;
      }

      return intervals.reduce(function (prev, curr) {
        return prev + curr.end_time - curr.start_time;
      }, 0);
    } // Sets is_augmented flag for duties that contain only augmented flights
    // note that the is_augmented flag can be a boolean or a crew count number

  }, {
    key: "flag_augmented_duties",
    value: function flag_augmented_duties(duties, flights) {
      if (!((duties != null ? duties.length : undefined) > 0) || !((flights != null ? flights.length : undefined) > 0)) {
        return;
      }

      duties.map(function (duty) {
        if (duty.type !== 'duty') {
          return;
        }

        var duty_day = afm.ScheduleHelper.get_duty_day(duties, duty);
        var flights_in_duty_day = afm.ScheduleHelper.find_flights_in_duty(duty_day, flights);
        duty.is_augmented = afm.ScheduleHelper.get_augmented_flag(flights_in_duty_day);
      });
    } // Combines the augmented duty information from more than one interval.
    // Because of the different ways augmented flags can be stored (as a boolean
    // or as a number) this logic is ugly.

  }, {
    key: "get_augmented_flag",
    value: function get_augmented_flag(intervals) {
      if (!((intervals != null ? intervals.length : undefined) > 0)) {
        return false;
      }

      return intervals.reduce(function (prev, curr) {
        if (!prev || curr.is_augmented == null) {
          return false;
        }

        if (typeof curr.is_augmented === 'boolean') {
          return curr.is_augmented;
        }

        var number = Number(curr.is_augmented);

        if (isNaN(number) || number < 3) {
          return false;
        }

        if (prev === true) {
          return true;
        }

        return Math.min(prev, number);
      }, 10);
    } // Returns array of duties that occur on the same duty day as the input duty.
    // Assumes that duties separated by less than 8.5 hours or
    // duties with is_split = true are on the same duty day.

  }, {
    key: "get_same_duty_day_duties",
    value: function get_same_duty_day_duties(duties, duty) {
      if (!((duties != null ? duties.length : undefined) > 0) || duty == null) {
        return [];
      }

      var should_continue = true;
      var duty_day = {
        start_time: duty.start_time,
        end_time: duty.end_time,
        metadata: duty.metadata
      };
      var to_return = [];

      while (should_continue) {
        should_continue = false;

        for (var _i7 = 0, _Array$from7 = Array.from(duties); _i7 < _Array$from7.length; _i7++) {
          var _d$metadata, _duty_day$metadata;

          var d = _Array$from7[_i7];

          if (d.type !== 'duty' || to_return.includes(d)) {
            continue;
          }

          if (afm.UtilitiesTime.hours_between_intervals(d, duty_day) < 8.5 || ((_d$metadata = d.metadata) === null || _d$metadata === void 0 ? void 0 : _d$metadata.is_split) && ((_duty_day$metadata = duty_day.metadata) === null || _duty_day$metadata === void 0 ? void 0 : _duty_day$metadata.is_split) && afm.ScheduleHelper.should_merge_split_duties(d, duty_day)) {
            to_return.push(d);
            duty_day = {
              start_time: Math.min(duty_day.start_time, d.start_time),
              end_time: Math.max(duty_day.end_time, d.end_time),
              metadata: duty_day.metadata
            };
            should_continue = true;
          }
        }
      }

      return to_return;
    } // Determines if the given duty and duty_day were originally split from the
    //  same duty due to a split break

  }, {
    key: "should_merge_split_duties",
    value: function should_merge_split_duties(d, duty_day) {
      var _d$metadata2, _duty_day$metadata2, _d$metadata3, _d$metadata4, _duty_day$metadata3, _duty_day$metadata4, _d$metadata5, _duty_day$metadata5, _d$metadata6, _duty_day$metadata6;

      if (!((_d$metadata2 = d.metadata) === null || _d$metadata2 === void 0 ? void 0 : _d$metadata2.is_split) || !((_duty_day$metadata2 = duty_day.metadata) === null || _duty_day$metadata2 === void 0 ? void 0 : _duty_day$metadata2.is_split)) {
        return false;
      } // backwards-compatible for data sets stored without the pre_split times


      if (isNaN((_d$metadata3 = d.metadata) === null || _d$metadata3 === void 0 ? void 0 : _d$metadata3.pre_split_start_time) || isNaN((_d$metadata4 = d.metadata) === null || _d$metadata4 === void 0 ? void 0 : _d$metadata4.pre_split_end_time) || isNaN((_duty_day$metadata3 = duty_day.metadata) === null || _duty_day$metadata3 === void 0 ? void 0 : _duty_day$metadata3.pre_split_end_time) || isNaN((_duty_day$metadata4 = duty_day.metadata) === null || _duty_day$metadata4 === void 0 ? void 0 : _duty_day$metadata4.pre_split_end_time)) {
        return afm.UtilitiesTime.hours_between_starts(d, duty_day) < 12.0;
      } // otherwise, use the start and end times to identify duties split from the same input duty


      return ((_d$metadata5 = d.metadata) === null || _d$metadata5 === void 0 ? void 0 : _d$metadata5.pre_split_start_time) === ((_duty_day$metadata5 = duty_day.metadata) === null || _duty_day$metadata5 === void 0 ? void 0 : _duty_day$metadata5.pre_split_start_time) && ((_d$metadata6 = d.metadata) === null || _d$metadata6 === void 0 ? void 0 : _d$metadata6.pre_split_end_time) === ((_duty_day$metadata6 = duty_day.metadata) === null || _duty_day$metadata6 === void 0 ? void 0 : _duty_day$metadata6.pre_split_end_time);
    } // returns the duty_day which contains the duty

  }, {
    key: "get_duty_day",
    value: function get_duty_day(duties, duty) {
      var same_day_duties = afm.ScheduleHelper.get_same_duty_day_duties(duties, duty);

      if (!((same_day_duties != null ? same_day_duties.length : undefined) > 0)) {
        return null;
      }

      return {
        start_time: Math.min.apply(Math, _toConsumableArray(Array.from(same_day_duties.map(function (d) {
          return d.start_time;
        }) || []))),
        end_time: Math.max.apply(Math, _toConsumableArray(Array.from(same_day_duties.map(function (d) {
          return d.end_time;
        }) || []))),
        origin: same_day_duties[0].origin,
        destination: same_day_duties.last().destination,
        is_in_wocl: same_day_duties.reduce(function (prev, curr) {
          return prev || curr.is_in_wocl;
        }, false),
        is_augmented: afm.ScheduleHelper.get_augmented_flag(same_day_duties)
      };
    } // returns a list of duty days for the set of duties

  }, {
    key: "get_duty_days",
    value: function get_duty_days(duties) {
      var duty_days = [];

      if (!((duties != null ? duties.length : undefined) > 0)) {
        return duty_days;
      }

      for (var _i8 = 0, _Array$from8 = Array.from(duties); _i8 < _Array$from8.length; _i8++) {
        var duty = _Array$from8[_i8];
        var duty_day = afm.ScheduleHelper.get_duty_day(duties, duty);

        if (!duty_day) {
          continue;
        }

        if (!duty_days.reduce(function (prev, curr) {
          return prev || afm.UtilitiesTime.intervals_intersect(curr, duty_day);
        }, false)) {
          duty_days.push(duty_day);
        }
      }

      return duty_days;
    } // returns the amount of rest opportunity between the previous interval (if any)
    // and the given interval

  }, {
    key: "get_prior_rest",
    value: function get_prior_rest(intervals, interval) {
      if (!interval || !((intervals === null || intervals === void 0 ? void 0 : intervals.length) > 0)) {
        return Number.POSITIVE_INFINITY;
      }

      var prior_rests = intervals.filter(function (i) {
        return i.type !== 'sleep';
      }).map(function (i) {
        return interval.start_time - i.end_time;
      }).filter(function (rest) {
        return rest > 0;
      });
      return Math.min.apply(Math, _toConsumableArray(prior_rests));
    } // returns true when the flight has rest period corresponding to
    // a gap in its respective duties;
    // this method should be used after duties have been split

  }, {
    key: "has_in_flight_rest",
    value: function has_in_flight_rest(intervals, flight) {
      if (!flight) {
        return false;
      }

      var duties = afm.ScheduleHelper.find_duties_for_interval(intervals, flight);

      if (duties.length === 0) {
        return true;
      } // combine the duties into non-intersecting intervals


      var combined = [];

      var _iterator4 = _createForOfIteratorHelper(duties),
          _step4;

      try {
        var _loop = function _loop() {
          var duty = _step4.value;
          var intersecting = combined.find(function (i) {
            return afm.UtilitiesTime.intervals_intersect(i, duty);
          });

          if (intersecting) {
            Object.assign(intersecting, {
              start_time: Math.min(intersecting.start_time, duty.start_time),
              end_time: Math.max(intersecting.end_time, duty.end_time)
            });
          } else {
            combined.push({
              start_time: duty.start_time,
              end_time: duty.end_time
            });
          }
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop();
        } // if there is more than one combined interval, then there must be a gap
        // in the intervals during the flight

      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      if (combined.length > 1) {
        return true;
      } // if there is exactly 1 combined interval, then there is in-flight rest
      // unless the combined interval contains the flight


      return !afm.UtilitiesTime.interval_contains(combined[0], flight);
    }
  }]);

  return ScheduleHelper;
}();
/* global afm */

/* eslint max-len: 0 */
// container class to hold all the data necessary to construct a schedule
// and methods to convert it to/from a serialized object


afm.Schedule = /*#__PURE__*/function () {
  function Schedule(preferences) {
    _classCallCheck(this, Schedule);

    this.preferences = preferences;
    this.data = {};
    this.errors = [];
  }

  _createClass(Schedule, [{
    key: "set_data",
    value: function set_data(data) {
      this.data = data;
    }
  }, {
    key: "get_data",
    value: function get_data() {
      return this.data;
    }
  }, {
    key: "deserialize",
    value: function deserialize(json) {
      this.data.start_date = this.parse_start_date(json.start_date);
      this.data.homebase_type = this.parse_airport_type(json.homebase_type);
      this.data.custom_airports = json.custom_airports;
      this.data.homebase = this.parse_homebase(json.homebase, this.data.homebase_type);
      this.data.time_entry_mode = json.time_entry_mode;
      this.data.auto_sleep = json.auto_sleep;
      this.data.name = json.name;
      this.data.notes = json.notes;
      this.data.metrics = json.metrics;

      if (this.data.start_date != null && (this.data.time_entry_mode === 'z' || this.data.time_entry_mode === 'l')) {
        this.data.intervals = this.parse_intervals(json.intervals, this.data.start_date, this.data.time_entry_mode);
      }

      this.data.timeline_settings = json.timeline_settings;
      this.data.prism = json.prism;
      this.data.fi = json.fi;
      this.data.visible_to_collaborators = json.visible_to_collaborators;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      if (this.errors.length > 0) {
        return {
          errors: this.errors
        };
      }

      return {
        start_date: afm.UtilitiesTime.convert_time_to_local_date_time_strings(this.data.start_date, 0).date,
        homebase_type: this.stringify_airport_type(this.data.homebase_type),
        homebase: this.stringify_airport(this.data.homebase, this.data.homebase_type),
        time_entry_mode: this.data.time_entry_mode,
        auto_sleep: this.data.auto_sleep,
        name: this.data.name,
        notes: this.data.notes,
        metrics: this.data.metrics,
        intervals: this.stringify_intervals_data(this.data.intervals, this.data.start_date, this.data.time_entry_mode),
        custom_airports: this.stringify_custom_airports(this.data.intervals, this.data.homebase),
        timeline_settings: this.data.timeline_settings,
        prism: this.data.prism,
        fi: this.data.fi,
        visible_to_collaborators: this.data.visible_to_collaborators
      };
    } // adds an error to the list of errors if it is not already present

  }, {
    key: "add_error",
    value: function add_error(type, msg, data) {
      var should_add = true;

      for (var _i9 = 0, _Array$from9 = Array.from(this.errors); _i9 < _Array$from9.length; _i9++) {
        var error = _Array$from9[_i9];

        if (error.type === type && error.msg === msg) {
          should_add = false;
        }
      }

      if (should_add) {
        return this.errors.push({
          type: type,
          msg: msg,
          data: data
        });
      }
    }
  }, {
    key: "add_intervals",
    value: function add_intervals(intervals) {
      this.data.intervals = this.data.intervals.concat(intervals);
    } // start_date must be in the form 'yyyy-mm-dd'

  }, {
    key: "parse_start_date",
    value: function parse_start_date(start_date_str) {
      if (start_date_str == null || typeof start_date_str !== 'string') {
        this.add_error('start date', "The 'start_date' is missing or not a string.");
        return;
      }

      var start_date = afm.UtilitiesTime.convert_date_string_to_date(start_date_str);

      if (typeof start_date !== 'number' || isNaN(start_date)) {
        this.add_error('start date', "The 'start_date' doesn't match the format 'yyyy-mm-dd'.");
        return;
      }

      return start_date;
    }
  }, {
    key: "parse_homebase",
    value: function parse_homebase(code, type) {
      var _this6 = this;

      if (!code) {
        this.add_error('homebase', 'The homebase is missing. Please enter a homebase.');
      } else {
        return this.parse_airport_code(code, type, function (code) {
          _this6.add_error('homebase', "The homebase '".concat(code, "' is not a recognized airport name. Please add a new location."));
        });
      }

      return null;
    } // airport type can be 'custom', 'iata', or 'icao' (default)

  }, {
    key: "parse_airport_type",
    value: function parse_airport_type(airport_type) {
      var type = airport_type != null ? airport_type.toLowerCase() : undefined;

      if (type === 'custom' || type === 'iata' || type === 'icao') {
        return type;
      } else {
        return 'icao';
      }
    }
  }, {
    key: "parse_airport_code",
    value: function parse_airport_code(code, type, error_handler) {
      // first try matching the exact type
      var airport;

      if (type === 'custom' && this.preferences && this.preferences.custom_airports) {
        airport = afm.LocationHelper.is_airport_code_valid(code, 'custom', this.preferences.custom_airports);

        if (airport != null) {
          return airport;
        }
      }

      if (type === 'custom' && this.data && this.data.custom_airports) {
        airport = afm.LocationHelper.is_airport_code_valid(code, 'custom', this.data.custom_airports);

        if (airport != null) {
          return airport;
        }
      }

      if (type === 'iata') {
        airport = afm.LocationHelper.is_airport_code_valid(code, 'iata');

        if (airport != null) {
          return airport;
        }
      }

      if (type === 'icao') {
        airport = afm.LocationHelper.is_airport_code_valid(code, 'icao');

        if (airport != null) {
          return airport;
        }
      } // then try matching anything


      airport = afm.LocationHelper.is_airport_code_valid(code, 'iata');

      if (airport != null) {
        return airport;
      }

      airport = afm.LocationHelper.is_airport_code_valid(code, 'icao');

      if (airport != null) {
        return airport;
      }

      if (this.preferences && this.preferences.custom_airports) {
        airport = afm.LocationHelper.is_airport_code_valid(code, 'custom', this.preferences.custom_airports);

        if (airport != null) {
          return airport;
        }
      }

      if ((this.data.custom_airports != null ? this.data.custom_airports.length : undefined) > 0) {
        airport = afm.LocationHelper.is_airport_code_valid(code, 'custom', this.data != null ? this.data.custom_airports : undefined);

        if (airport != null) {
          return airport;
        }
      } // otherwise give up and add an error


      if (error_handler) {
        error_handler(code);
      } else {
        this.add_error('airport', "The airport '".concat(code, "' is not a recognized airport name. Please add a new location."), {
          airport_name: code
        });
      }

      return null;
    }
  }, {
    key: "parse_intervals",
    value: function parse_intervals(intervals, start_date, time_entry_mode) {
      var to_return = [];

      if ((intervals != null ? intervals.length : undefined) != null && intervals.length > 0) {
        for (var i = 0; i < intervals.length; i++) {
          var interval = intervals[i];
          var interval_data = this.parse_interval(interval, start_date, time_entry_mode);

          if (interval_data != null) {
            to_return.push(interval_data);
          }
        }
      }

      return to_return;
    }
  }, {
    key: "parse_interval",
    value: function parse_interval(interval, start_date, time_entry_mode) {
      var type = this.parse_interval_type(interval);
      var origin_type = this.parse_airport_type(interval.origin_type);
      var destination_type = this.parse_airport_type(interval.destination_type);
      var origin = this.parse_airport_code(interval.origin, origin_type);
      var destination = this.parse_airport_code(interval.destination, destination_type);
      var start_time = this.parse_interval_date_time_strings(origin, interval.start_date, interval.start_time, start_date, time_entry_mode);
      var end_time = this.parse_interval_date_time_strings(destination, interval.end_date, interval.end_time, start_date, time_entry_mode);
      var is_augmented = this.parse_is_augmented(interval);
      var metadata = interval.metadata;
      return {
        type: type,
        origin: origin,
        start_time: start_time,
        destination: destination,
        end_time: end_time,
        is_augmented: is_augmented,
        metadata: metadata
      };
    }
  }, {
    key: "parse_interval_type",
    value: function parse_interval_type(interval) {
      var type = interval.type;

      if (type == null) {
        this.add_error('interval type', 'An interval is missing a type.', {
          interval: interval
        });
        return;
      }

      if (type !== 'flight' && type !== 'duty' && type !== 'sleep') {
        this.add_error('interval type', "An interval type must be 'flight', 'duty', or 'sleep'.", {
          interval: interval
        });
        return;
      }

      return type;
    }
  }, {
    key: "parse_interval_date_time_strings",
    value: function parse_interval_date_time_strings(airport, date_str, time_str, start_date, time_entry_mode) {
      if (date_str == null || typeof date_str !== 'string') {
        this.add_error('interval date/time', 'An interval is missing a start or end date.', {
          date: date_str
        });
        return;
      }

      if (time_str == null || typeof time_str !== 'string') {
        this.add_error('interval date/time', 'An interval is missing a start or end time.', {
          time: time_str
        });
        return;
      }

      var time = afm.UtilitiesTime.convert_local_date_time_strings_to_time(start_date, {
        date: date_str,
        time: time_str
      }, time_entry_mode === 'l' ? airport : undefined);

      if (time == null) {
        this.add_error('interval date/time', "An interval date and time couldn't be parsed.", {
          date: date_str,
          time: time_str
        });
        return;
      }

      return time;
    }
  }, {
    key: "parse_is_augmented",
    value: function parse_is_augmented(interval) {
      if ((interval != null ? interval.is_augmented : undefined) == null) {
        return false;
      }

      if (typeof interval.is_augmented === 'boolean') {
        return interval.is_augmented;
      }

      var number = Number(interval.is_augmented);

      if (number < 3 || isNaN(number)) {
        return false;
      }

      return number;
    }
  }, {
    key: "stringify_airport",
    value: function stringify_airport(airport, airport_type) {
      if (airport_type === 'iata') {
        return airport.iata;
      } else if (airport_type === 'custom') {
        return airport.custom_name;
      } else {
        return airport.icao;
      }
    }
  }, {
    key: "stringify_airport_type",
    value: function stringify_airport_type(airport_type) {
      switch (airport_type) {
        case 'custom':
          return 'custom';

        case 'iata':
          return 'iata';

        default:
          return 'icao';
      }
    }
  }, {
    key: "stringify_intervals_data",
    value: function stringify_intervals_data(intervals_data, start_date, time_entry_mode) {
      var _this7 = this;

      if (intervals_data == null || !(intervals_data.length > 0)) {
        return [];
      }

      return intervals_data.map(function (x) {
        return _this7.stringify_interval_data(x, start_date, time_entry_mode);
      });
    }
  }, {
    key: "stringify_interval_data",
    value: function stringify_interval_data(interval_data, start_date, time_entry_mode) {
      var _this8 = this;

      var start_dt_strings = afm.UtilitiesTime.convert_time_to_local_date_time_strings(start_date, interval_data.start_time, time_entry_mode === 'l' ? interval_data.origin : undefined);
      var end_dt_strings = afm.UtilitiesTime.convert_time_to_local_date_time_strings(start_date, interval_data.end_time, time_entry_mode === 'l' ? interval_data.destination : undefined);
      var origin_type = this.stringify_airport_type(function () {
        switch (false) {
          case !interval_data.origin.is_custom:
            return 'custom';

          case (_this8.preferences != null ? _this8.preferences.default_airport_type : undefined) !== 'iata':
            return 'iata';

          default:
            return 'icao';
        }
      }());
      var origin = this.stringify_airport(interval_data.origin, origin_type);
      var destination_type = this.stringify_airport_type(function () {
        switch (false) {
          case !interval_data.destination.is_custom:
            return 'custom';

          case (_this8.preferences != null ? _this8.preferences.default_airport_type : undefined) !== 'iata':
            return 'iata';

          default:
            return 'icao';
        }
      }());
      var destination = this.stringify_airport(interval_data.destination, destination_type);
      return {
        type: interval_data.type,
        origin_type: origin_type,
        origin: origin,
        start_date: start_dt_strings.date,
        start_time: start_dt_strings.time,
        destination_type: destination_type,
        destination: destination,
        end_date: end_dt_strings.date,
        end_time: end_dt_strings.time,
        is_augmented: this.parse_is_augmented(interval_data),
        metadata: interval_data.metadata
      };
    }
  }, {
    key: "stringify_custom_airports",
    value: function stringify_custom_airports(intervals_data, homebase) {
      var custom_airports = [];

      if (homebase.is_custom) {
        this.append_custom_airport(custom_airports, homebase);
      }

      if (intervals_data == null || !(intervals_data.length > 0)) {
        return custom_airports;
      }

      for (var _i10 = 0, _Array$from10 = Array.from(intervals_data); _i10 < _Array$from10.length; _i10++) {
        var interval = _Array$from10[_i10];

        if (interval.origin != null ? interval.origin.is_custom : undefined) {
          custom_airports = this.append_custom_airport(custom_airports, interval.origin);
        }

        if (interval.destination != null ? interval.destination.is_custom : undefined) {
          custom_airports = this.append_custom_airport(custom_airports, interval.destination);
        }
      }

      return custom_airports;
    }
  }, {
    key: "append_custom_airport",
    value: function append_custom_airport(custom_airports, airport) {
      if (!(airport != null ? airport.is_custom : undefined)) {
        return custom_airports;
      }

      var custom_codes = custom_airports.map(function (a) {
        return a.custom_name;
      });

      if (custom_codes.includes(airport.custom_name)) {
        return custom_airports;
      }

      custom_airports.push({
        custom_name: airport.custom_name,
        custom_abbr: airport.custom_abbr,
        nearest_airport: airport.nearest_airport,
        nearest_airport_type: airport.nearest_airport_type
      });
      return custom_airports;
    }
  }, {
    key: "is_valid",
    value: function is_valid() {
      return this.errors.length === 0;
    }
  }, {
    key: "get_time_span",
    value: function get_time_span() {
      var _this$data$intervals;

      if (!(((_this$data$intervals = this.data.intervals) === null || _this$data$intervals === void 0 ? void 0 : _this$data$intervals.length) > 0)) {
        return {
          start_time: 0,
          end_time: 0
        };
      }

      var start_times = this.data.intervals.map(function (x) {
        return x.start_time;
      });
      var start_time = Math.min.apply(Math, _toConsumableArray(Array.from(start_times || [])));
      var end_times = this.data.intervals.map(function (x) {
        return x.end_time;
      });
      var end_time = Math.max.apply(Math, _toConsumableArray(Array.from(end_times || [])));
      return {
        start_time: start_time,
        end_time: end_time
      };
    }
  }]);

  return Schedule;
}();
/* global afm $ XMLSerializer Image btoa */
// Adapted from http://bl.ocks.org/Rokotyan/0556f8facbaf344507cdc45dc3622177


afm.SVGToPNGConverter = /*#__PURE__*/function () {
  function SVTToPNGConverter() {
    _classCallCheck(this, SVTToPNGConverter);
  }

  _createClass(SVTToPNGConverter, [{
    key: "getSVGString",
    value: function getSVGString(svgNode) {
      svgNode.setAttribute('xlink', 'http://www.w3.org/1999/xlink');
      var cssStyleText = this.getCSSStyles(svgNode);
      this.appendCSS(cssStyleText, svgNode);
      var serializer = new XMLSerializer();
      var svgString = serializer.serializeToString(svgNode); // Fix root xlink without namespace

      svgString = svgString.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink='); // Safari NS namespace fix

      svgString = svgString.replace(/NS\d+:href/g, 'xlink:href');
      return svgString;
    }
  }, {
    key: "getCSSStyles",
    value: function getCSSStyles(parentElement) {
      var selectorTextArr = []; // Add Parent element Id and Classes to the list

      selectorTextArr.push('#' + parentElement.id);

      var _iterator5 = _createForOfIteratorHelper(parentElement.classList),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var klass = _step5.value;

          if (!selectorTextArr.includes('.' + klass)) {
            selectorTextArr.push('.' + klass);
          }
        } // Add Children element Ids and Classes to the list

      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var _iterator6 = _createForOfIteratorHelper(parentElement.getElementsByTagName('*')),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var node = _step6.value;
          var id = node.id;

          if (!selectorTextArr.includes('#' + id)) {
            selectorTextArr.push('#' + id);
          }

          var _iterator8 = _createForOfIteratorHelper(node.classList),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _klass = _step8.value;

              if (!selectorTextArr.includes('.' + _klass)) {
                selectorTextArr.push('.' + _klass);
              }
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        } // Extract CSS Rules

      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      var extractedCSSText = '';

      var _iterator7 = _createForOfIteratorHelper(document.styleSheets),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var s = _step7.value;

          try {
            if (!s.cssRules) {
              continue;
            }
          } catch (e) {
            if (e.name !== 'SecurityError') {
              throw e;
            } // for Firefox


            continue;
          }

          var _iterator9 = _createForOfIteratorHelper(s.cssRules),
              _step9;

          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var cssRule = _step9.value;

              if (selectorTextArr.includes(cssRule.selectorText)) {
                extractedCSSText += cssRule.cssText;
              }
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return extractedCSSText;
    }
  }, {
    key: "appendCSS",
    value: function appendCSS(cssText, element) {
      var styleElement = document.createElement('style');
      styleElement.setAttribute('type', 'text/css');
      styleElement.innerHTML = cssText;
      var refNode = element.hasChildNodes() ? element.children[0] : null;
      element.insertBefore(styleElement, refNode);
    } // converts the <svg> DOM object to a png image string

  }, {
    key: "convert_to_png_str",
    value: function convert_to_png_str(svg, width, height, callback) {
      var svgString = this.getSVGString(svg.node());
      var imgsrc = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      Object.assign(canvas, {
        width: width,
        height: height
      });
      var image = new Image();

      image.onload = function () {
        context.clearRect(0, 0, width, height);
        context.drawImage(image, 0, 0, width, height);
        var png = canvas.toDataURL();

        if (callback) {
          callback(png);
        }
      };

      image.src = imgsrc;
    } // converts the <svg> DOM object to a png image jQuery object

  }, {
    key: "convert",
    value: function convert(svg, width, height, callback) {
      this.convert_to_png_str(svg, width, height, function (src) {
        var img = $('<img>', {
          src: src
        });

        if (callback) {
          callback(img);
        }
      });
    }
  }]);

  return SVTToPNGConverter;
}();
/* global afm mixpanel Raven */
// Wrapper for tracking user events


afm.Tracker = /*#__PURE__*/function () {
  function Tracker() {
    _classCallCheck(this, Tracker);
  }

  _createClass(Tracker, null, [{
    key: "initialize",
    value: function initialize() {
      var preferences = {};

      if (afm.DataStore.data.preferences) {
        preferences = afm.DataStore.data.preferences.toJSON();
      } // mixpanel tracking


      var data = {
        $email: preferences.email,
        $last_login: new Date(),
        is_pro_fm_user: preferences.is_pro_fm_user,
        is_fi_user: preferences.is_fi_user,
        is_prism_frat_user: preferences.is_prism_frat_user
      };

      if (preferences.first_name && preferences.first_name.length > 0) {
        data.$first_name = preferences.first_name;
      }

      if (preferences.last_name && preferences.last_name.length > 0) {
        data.$last_name = preferences.last_name;
      }

      if (preferences.company_key && preferences.company_key.length > 0) {
        data.company_key = preferences.company_key;
      }

      if (typeof mixpanel !== 'undefined') {
        mixpanel.identify(preferences.user);
        mixpanel.people.set(data);
      } // sentry tracking


      if (typeof Raven !== 'undefined') {
        Raven.setUserContext({
          user: {
            email: preferences.email
          }
        });
      }
    }
  }, {
    key: "track",
    value: function track(event) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof mixpanel === 'undefined') {
        return;
      }

      mixpanel.track(event, args);
    }
  }]);

  return Tracker;
}();
/* global afm $ d3 FileReader Blob alert location */
// returns the last element of an array


if (Array.prototype.last == null) {
  Array.prototype.last = function (arg) {
    if (arg != null) {
      if (this.length > 0) {
        this[this.length - 1] = arg;
      } else {
        this[0] = arg;
      }

      return arg;
    }

    if (this.length > 0) {
      return this[this.length - 1];
    }

    return null;
  };
} // returns true if two arrays contain the same set of objects


if (Array.prototype.matches_array == null) {
  Array.prototype.matches_array = function (array) {
    if (!array) {
      return false;
    }

    if (array.length !== this.length) {
      return false;
    }

    var _iterator10 = _createForOfIteratorHelper(array),
        _step10;

    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var item = _step10.value;

        if (!this.includes(item)) {
          return false;
        }
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }

    return true;
  };
} // general purpose throttling function
// - fn is the function to be throttled
// - id is a unique identifier for the function (so that throttle can be reused
//   across multiple functions simultaneously)
// - delay is the minimum time between function calls


var throttle_data = {
  timeout: {},
  time_last_called: {}
}; // general purpose debounce function
// - fn is debounced function
// - id is a unique identifier for the function (so that debounce can be reused
//   across multiple functions simultaneously)
// - timeout is time in ms to wait since last time debounce was invoked before
//   invoking fn

var debounce_data = {}; // generic utilities used across the app

afm.UtilitiesCS = /*#__PURE__*/function () {
  function UtilitiesCS() {
    _classCallCheck(this, UtilitiesCS);
  }

  _createClass(UtilitiesCS, null, [{
    key: "throttle",
    value: function throttle(fn, id, delay) {
      var now = +new Date();

      if (throttle_data.time_last_called[id] && now < throttle_data.time_last_called[id] + delay) {
        clearTimeout(throttle_data.timeout[id]);
        var to_delay = throttle_data.time_last_called[id] + delay - now;
        throttle_data.timeout[id] = setTimeout(function () {
          throttle_data.time_last_called[id] = now + to_delay;
          return fn();
        }, to_delay);
      } else {
        throttle_data.time_last_called[id] = now;
        fn();
      }
    }
  }, {
    key: "debounce",
    value: function debounce(fn, id, timeout) {
      if (debounce_data[id] != null) {
        clearTimeout(debounce_data[id]);
      }

      debounce_data[id] = setTimeout(fn, timeout);
    } // repositions any active dialog object

  }, {
    key: "reposition_active_dialog",
    value: function reposition_active_dialog() {
      if (typeof $ === 'undefined') {
        return;
      }

      var dialog = $('.ui-dialog:visible').find('.ui-dialog-content');
      dialog.dialog('option', 'position', dialog.dialog('option', 'position'));
    } // attempts to read json data from a text file asychronously
    // triggers a 'file_completed_event' containing the json data when successful
    // and an error if one occurred

  }, {
    key: "read_json_from_text_file",
    value: function read_json_from_text_file(file) {
      var _this9 = this;

      var reader = new FileReader();

      reader.onload = function (e) {
        var err, json;

        try {
          json = JSON.parse(e.target.result);
        } catch (error) {
          err = error;
        }

        return $(_this9).trigger('file_read_completed', {
          json: json,
          err: err
        });
      };

      return reader.readAsText(file);
    } // attempts to read a text file asychronously
    // triggers a 'file_completed_event' containing the data when successful and
    // an error if one occurred

  }, {
    key: "read_text_from_text_file",
    value: function read_text_from_text_file(file) {
      var _this10 = this;

      var reader = new FileReader();

      reader.onload = function (e) {
        return $(_this10).trigger('file_read_completed', {
          data: e.target.result
        });
      };

      return reader.readAsText(file);
    } // creates a text file blob from a json object
    // returns the url pointing to the file

  }, {
    key: "create_text_file_blob_from_json",
    value: function create_text_file_blob_from_json(json, option) {
      var str;

      switch (option) {
        case 'pretty_print':
          // the tab option produces a pretty-print-like format
          str = JSON.stringify(json, null, '\t');
          break;

        case 'csv':
          str = d3.csvFormatRows(json);
          break;

        default:
          str = JSON.stringify(json);
      }

      return new Blob([str], {
        type: 'text/javascript'
      });
    } // triggers a file download for a blob

  }, {
    key: "initiate_file_download",
    value: function initiate_file_download(blob, file_name, view) {
      // if IE, trigger their special blob save syntax
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, file_name);
        return;
      }

      var url = window.URL.createObjectURL(blob); // if ios navigate to the url

      if (this.is_ios()) {
        window.location.href = url;
        return;
      } // else, create a dummy save link and trigger a click on it
      // to initiate file download


      var dummy_view = $("<a href=".concat(url, " download=").concat(file_name, " target='blank'></a>"));
      view.append(dummy_view);
      dummy_view[0].click();
      dummy_view.remove();
    } // compare two strings, because javascript doesn't have a built in method (?!)

  }, {
    key: "compare_strings",
    value: function compare_strings(a, b) {
      switch (false) {
        case !(a < b):
          return -1;

        case !(a > b):
          return 1;

        default:
          return 0;
      }
    } // escapes a string for safe use in a regexp
    // see http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex

  }, {
    key: "escape_reg_exp",
    value: function escape_reg_exp(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    }
  }, {
    key: "encode_html",
    // encodes text for safe use in HTML body content
    value: function encode_html(str) {
      var multiline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (typeof $ === 'undefined') {
        return null;
      }

      if (!str) {
        return str;
      }

      var sanitized = '';
      var allowed_regexp = new RegExp('(' + this.allowed_html_entities.join('|') + ')', 'i');
      var chunks = str.split(allowed_regexp);

      var _iterator11 = _createForOfIteratorHelper(chunks),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var chunk = _step11.value;

          if (this.allowed_html_entities.includes(chunk.toLowerCase())) {
            sanitized += chunk;
          } else {
            var sanitized_chunk = $('<div/>').text(chunk).html();
            sanitized += sanitized_chunk;
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      if (multiline) {
        sanitized = sanitized.replace(/\n/g, '<br>');
      }

      return sanitized;
    }
  }, {
    key: "filename_safe_string",
    value: function filename_safe_string(str) {
      var maxlength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;
      return ('' + str).trim().replace(/\s+/g, '_').replace(/[^a-z0-9_]/gi, '').substring(0, maxlength);
    } // Returns an array with n linearly spaced number between a and b

  }, {
    key: "linspace",
    value: function linspace(a, b, n, should_round) {
      var step = (b - a) / (n - 1);
      var array = [];
      var i = 0;

      while (i < n) {
        array.push(should_round ? Math.round(a + i * step) : a + i * step);
        i++;
      }

      return array;
    } // Matrix transpose of A

  }, {
    key: "transpose",
    value: function transpose(A) {
      var m = A.length;
      var n = A[0].length;
      var T = new Array(n);

      for (var j = 0; j <= n - 1; j++) {
        T[j] = new Array(m);

        for (var i = 0; i <= m - 1; i++) {
          T[j][i] = A[i][j];
        }
      }

      return T;
    } // Runge Kutta 4-5

  }, {
    key: "rk45",
    value: function rk45(f, tSpan, y0, h) {
      var l = Math.max(1, Math.ceil((tSpan[1] - tSpan[0]) / h));
      var y = new Array(l);
      y[0] = y0;
      var t = new Array(l);
      t[0] = tSpan[0];
      var size = y0.length;
      var yEst = new Array(size);
      var n = 0;
      var i;

      while (t[n] < tSpan[1]) {
        // Don't go beyond tSpan[1]
        if (t[n] + h > tSpan[1]) {
          h = tSpan[1] - t[n];
        }

        var k1 = f(t[n], y[n]);

        for (i = 0; i <= size - 1; i++) {
          yEst[i] = y[n][i] + h / 2 * k1[i];
        }

        var k2 = f(t[n] + h / 2, yEst);

        for (i = 0; i <= size - 1; i++) {
          yEst[i] = y[n][i] + h / 2 * k2[i];
        }

        var k3 = f(t[n] + h / 2, yEst);

        for (i = 0; i <= size - 1; i++) {
          yEst[i] = y[n][i] + h * k3[i];
        }

        var k4 = f(t[n] + h, yEst);
        y[n + 1] = new Array(size);

        for (i = 0; i <= size - 1; i++) {
          y[n + 1][i] = y[n][i] + h / 6 * (k1[i] + 2 * k2[i] + 2 * k3[i] + k4[i]);
        }

        t[n + 1] = t[n] + h;
        n++;
      }

      return {
        t: t,
        y: this.transpose(y),
        y_t: y,
        evals: n * 4
      };
    } // Runge Kutta 4-5 with a non-linear

  }, {
    key: "rk45_with_non_linear_output",
    value: function rk45_with_non_linear_output(f, tSpan, y0, h, gFun) {
      var l = Math.max(1, Math.ceil((tSpan[1] - tSpan[0]) / h));
      var y = new Array(l);
      y[0] = y0;
      var t = new Array(l);
      t[0] = tSpan[0];
      var size = y0.length;
      var yEst = new Array(size);
      var n = 0;
      var i;

      while (t[n] < tSpan[1]) {
        // Don't go beyond tSpan[1]
        if (t[n] + h > tSpan[1]) {
          h = tSpan[1] - t[n];
        }

        var k1 = f(t[n], y[n]);

        for (i = 0; i <= size - 1; i++) {
          yEst[i] = y[n][i] + h / 2 * k1[i];
        }

        var k2 = f(t[n] + h / 2, yEst);

        for (i = 0; i <= size - 1; i++) {
          yEst[i] = y[n][i] + h / 2 * k2[i];
        }

        var k3 = f(t[n] + h / 2, yEst);

        for (i = 0; i <= size - 1; i++) {
          yEst[i] = y[n][i] + h * k3[i];
        }

        var k4 = f(t[n] + h, yEst);
        y[n + 1] = new Array(size);

        for (i = 0; i <= size - 1; i++) {
          y[n + 1][i] = y[n][i] + h / 6 * (k1[i] + 2 * k2[i] + 2 * k3[i] + k4[i]);
        }

        y[n + 1] = gFun(t[n] + h, y[n + 1]);
        t[n + 1] = t[n] + h;
        n++;
      }

      return {
        t: t,
        y: this.transpose(y),
        y_t: y,
        evals: n * 4
      };
    }
  }, {
    key: "add_arrays",
    value: function add_arrays(arr1, arr2) {
      if (!Array.isArray(arr1) || !Array.isArray(arr2) || arr1.length !== arr2.length) {
        return null;
      }

      var result = arr1.slice();

      for (var i = 0; i < arr2.length; i++) {
        var value = arr2[i];
        result[i] += value;
      }

      return result;
    } // partitions the elements of an array into at most 'num' separate arrays

  }, {
    key: "partition_array",
    value: function partition_array(array, num) {
      if (array == null) {
        return [];
      }

      if (!(num > 1)) {
        return [array];
      }

      if (!(num < array.length)) {
        return array.map(function (a) {
          return [a];
        });
      }

      var to_return = [];

      for (var i = 0; i <= num - 1; i++) {
        to_return.push(array.slice(Math.ceil(i * array.length / num), Math.ceil((i + 1) * array.length / num)));
      }

      return to_return;
    } // computes the circular difference between two phases (mod 24)

  }, {
    key: "circular_difference",
    value: function circular_difference(x, y) {
      if (!isFinite(x) || !isFinite(y)) {
        return null;
      }

      if (y === 0) {
        return x;
      }

      if (x === y) {
        return 0;
      }

      var arg = x - y + 12.0;
      var n = Math.floor(arg / 24.0);
      return arg - n * 24.0 - 12.0;
    }
  }, {
    key: "is_ios",
    value: function is_ios() {
      return window.navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
    }
  }, {
    key: "is_ios_standalone",
    value: function is_ios_standalone() {
      return this.is_ios() && 'standalone' in window.navigator && window.navigator.standalone;
    }
  }, {
    key: "get_ios_version",
    value: function get_ios_version() {
      if (this.is_ios()) {
        return this.parse_ios_version();
      }

      return '';
    }
  }, {
    key: "is_msie",
    value: function is_msie() {
      var match = window.navigator.userAgent.match(/MSIE|Trident.*rv\:11\./);
      return match && match.length > 0;
    }
  }, {
    key: "is_msie_edge",
    value: function is_msie_edge() {
      var match = window.navigator.userAgent.match(/Edge/);
      return match && match.length > 0;
    }
  }, {
    key: "parse_ios_version",
    value: function parse_ios_version() {
      return parseInt(window.navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10);
    }
  }, {
    key: "test_browser_supports_web_workers",
    value: function test_browser_supports_web_workers() {
      if (typeof Worker === 'undefined') {
        return alert('Your browser is not supported by Aviation Fatigue Meter. Please use ' + 'IE10, IE11, Firefox, Chrome, Safari, or the iPad browser.');
      }
    }
  }, {
    key: "test_browser_supports_cookies",
    value: function test_browser_supports_cookies() {
      this.createCookie('test', '1', 1);
      var cookie_set = this.readCookie('test');
      this.eraseCookie('test');

      if (!cookie_set) {
        alert('Your browser is configured to not accept cookies. Cookies are needed' + ' to log in and use Aviation Fatigue Meter. Please change your' + ' browser settings.');
      }

      return cookie_set;
    }
  }, {
    key: "createCookie",
    value: function createCookie(name, value, days) {
      var expires;

      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=".concat(date.toGMTString());
      } else {
        expires = '';
      }

      document.cookie = name + '=' + value + expires + '; path=/';
    }
  }, {
    key: "readCookie",
    value: function readCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      var i = 0;

      while (i < ca.length) {
        var c = ca[i];

        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }

        i++;
      }

      return null;
    }
  }, {
    key: "eraseCookie",
    value: function eraseCookie(name) {
      this.createCookie(name, '', -1);
    }
  }, {
    key: "get_url_parameter",
    value: function get_url_parameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp("[\\?&]".concat(name, "=([^&#]*)"));
      var results = regex.exec(location.search);

      if (!results) {
        return '';
      }

      return decodeURIComponent(results[1].replace(/\+/g, ' '));
    } // Toggles a class based on the condition argument

  }, {
    key: "add_remove_class",
    value: function add_remove_class(jquery_obj, class_name, condition) {
      if (condition) {
        jquery_obj.addClass(class_name);
      } else {
        jquery_obj.removeClass(class_name);
      }
    }
  }, {
    key: "fatigue_colors",
    value: function fatigue_colors() {
      return ['#FFFFFF', '#FFD86D', '#FFB10A', '#FF8D00', '#EE702E', '#E04500', '#DD2700', '#BF0000'];
    }
  }, {
    key: "fatigue_color_gradient",
    value: function fatigue_color_gradient() {
      var _this11 = this;

      return this.fatigue_colors().map(function (color, i) {
        return {
          color: color,
          offset: "".concat(i / (_this11.fatigue_colors().length - 1) * 100, "%")
        };
      });
    } // returns a nicely formatted user name

  }, {
    key: "get_name",
    value: function get_name() {
      var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var first_name = user.first_name,
          last_name = user.last_name,
          email = user.email;

      if (first_name && first_name.length > 0 && last_name && last_name.length > 0) {
        return "".concat(first_name, " ").concat(last_name);
      }

      if (first_name && first_name.length > 0 && email && email.length > 0) {
        return "".concat(first_name, " ").concat(email);
      }

      if (first_name && first_name.length > 0) {
        return first_name;
      }

      if (email && email.length > 0) {
        return email;
      }

      return '';
    } // returns a user's initials

  }, {
    key: "get_initials",
    value: function get_initials() {
      var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var first_name = user.first_name,
          last_name = user.last_name,
          email = user.email;

      if ((first_name === null || first_name === void 0 ? void 0 : first_name.length) > 0 && (last_name === null || last_name === void 0 ? void 0 : last_name.length) > 0) {
        return "".concat(first_name[0].toUpperCase()).concat(last_name[0].toUpperCase());
      }

      if ((first_name === null || first_name === void 0 ? void 0 : first_name.length) > 0) {
        return "".concat(first_name[0].toUpperCase());
      }

      if ((email === null || email === void 0 ? void 0 : email.length) > 0) {
        return email[0].toUpperCase();
      }

      return '';
    } // returns a display-friendly truncation of the user's email

  }, {
    key: "truncate_email",
    value: function truncate_email() {
      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.capitalize(email.split('@')[0]);
    } // rounds the number to the nearest 'places' decimal places

  }, {
    key: "round",
    value: function round(number) {
      var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var factor = Math.pow(10, places);
      return Math.round(number * factor) / factor;
    } // converts the integer number to the equivalent english word

  }, {
    key: "convert_num_to_word",
    value: function convert_num_to_word(number) {
      if (!Number.isInteger(number)) {
        return '';
      }

      if (number > 10) {
        return 'ten+';
      }

      return ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'][number];
    } // capitalizes the string

  }, {
    key: "capitalize",
    value: function capitalize(str) {
      if (!str) {
        return str;
      }

      return str[0].toUpperCase() + str.slice(1);
    }
  }, {
    key: "allowed_html_entities",
    get: function get() {
      return ['&ndash;', '&mdash;', '&copy;', '&reg;', '&nbsp;', '<br>', '<br\/>'];
    }
  }]);

  return UtilitiesCS;
}();
/* global afm d3 */


var _format_timezone, _format_hours_minutes, _format_year_month_day, _utc_format_year_month_day, _format_month_day_hours, _parse_year_month_day_hours_minutes, _parse_hours_minutes;

var try_parse_time_string_formats = [];
var try_parse_date_string_formats = [];

if (typeof d3 !== 'undefined') {
  _format_timezone = d3.timeFormat('%Z');
  _format_hours_minutes = d3.timeFormat('%H:%M');
  _format_year_month_day = d3.timeFormat('%Y-%m-%d');
  _utc_format_year_month_day = d3.utcFormat('%Y-%m-%d');
  _format_month_day_hours = d3.timeFormat('%m/%d %H%p');
  _parse_year_month_day_hours_minutes = d3.timeParse('%Y-%m-%d %H:%M');
  _parse_hours_minutes = d3.timeParse('%H:%M'); // formats to try when parsing a free-text time string

  try_parse_time_string_formats = [d3.timeParse('%H%M'), d3.timeParse('%H'), d3.timeParse(':%M'), d3.timeParse('%H:%M'), d3.timeParse('%H%M%p'), d3.timeParse('%H%p'), d3.timeParse('%H%M %p'), d3.timeParse('%H %p')]; // formats to try when parsing a free-text date string

  try_parse_date_string_formats = [d3.timeParse('%Y-%m-%d'), d3.timeParse('%m/%d/%y'), d3.timeParse('%x')];
} // create a fake airport always in Z for Z-time calculations below


var z_airport = {
  timezone: 0
};

afm.UtilitiesTime = /*#__PURE__*/function () {
  function UtilitiesTime() {
    _classCallCheck(this, UtilitiesTime);
  }

  _createClass(UtilitiesTime, null, [{
    key: "format_timezone",
    value: function format_timezone(date) {
      return _format_timezone ? _format_timezone(date) : null;
    }
  }, {
    key: "format_hours_minutes",
    value: function format_hours_minutes(date) {
      return _format_hours_minutes ? _format_hours_minutes(date) : null;
    }
  }, {
    key: "format_year_month_day",
    value: function format_year_month_day(date) {
      return _format_year_month_day ? _format_year_month_day(date) : null;
    }
  }, {
    key: "utc_format_year_month_day",
    value: function utc_format_year_month_day(date) {
      return _utc_format_year_month_day ? _utc_format_year_month_day(date) : null;
    }
  }, {
    key: "parse_year_month_day_hours_minutes",
    value: function parse_year_month_day_hours_minutes(date) {
      return _parse_year_month_day_hours_minutes ? _parse_year_month_day_hours_minutes(date) : null;
    }
  }, {
    key: "format_month_day_hours",
    value: function format_month_day_hours(date) {
      return _format_month_day_hours ? _format_month_day_hours(date) : null;
    }
  }, {
    key: "parse_hours_minutes",
    value: function parse_hours_minutes(str) {
      return _parse_hours_minutes ? _parse_hours_minutes(str) : null;
    } // formats two javascript dates into readable format

  }, {
    key: "format_date_range",
    value: function format_date_range(date_1, date_2) {
      if (!date_1 && !date_2) {
        return;
      }

      if (!date_2) {
        return d3.utcFormat('%d %b %Y')(date_1);
      }

      var sd_format;

      if (date_1.getUTCFullYear() < date_2.getUTCFullYear()) {
        sd_format = d3.utcFormat('%d %b %Y');
      } else if (date_1.getUTCMonth() < date_2.getUTCMonth()) {
        sd_format = d3.utcFormat('%d %b');
      } else {
        sd_format = d3.utcFormat('%d');
      }

      var ed_format = d3.utcFormat('%d %b %Y');
      return "".concat(sd_format(date_1), "&mdash;").concat(ed_format(date_2));
    } // use to convert airport dst start/end strings into local dates

  }, {
    key: "parse_airport_dst_field",
    value: function parse_airport_dst_field(str) {
      var strs = str.split(' ');
      var d = strs[0].split('-');
      var t = strs[1].split(':');
      return new Date(d[0], d[1] - 1, d[2], t[0], t[1]);
    }
  }, {
    key: "format_timezone_string",
    value: function format_timezone_string(offset, include_parentheses) {
      var result = function () {
        switch (false) {
          case !(offset > 0):
            return "Z+".concat(offset);

          case !(offset < 0):
            return "Z".concat(offset);

          default:
            return 'Z';
        }
      }();

      if (include_parentheses) {
        return "(".concat(result, ")");
      } else {
        return result;
      }
    } // converts a time (in hours from the start_date) to the local date and
    //  time strings at the given location, accounting for timezone and
    // DST adjustments

  }, {
    key: "convert_time_to_local_date_time_strings",
    value: function convert_time_to_local_date_time_strings(start_date, time, airport) {
      var date = this.convert_time_to_local_date(start_date, time, airport);
      return {
        date: this.format_year_month_day(date),
        time: this.format_hours_minutes(date)
      };
    } // converts local date & time strings to a time
    // (in hours from the start_date), accounting for timezone and
    // DST adjustments

  }, {
    key: "convert_local_date_time_strings_to_time",
    value: function convert_local_date_time_strings_to_time(start_date) {
      var strings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var airport = arguments.length > 2 ? arguments[2] : undefined;
      var date_string = strings.date;
      var time_string = strings.time;

      if (!date_string || !time_string) {
        return null;
      } // convert the strings to a local date


      var date = this.parse_year_month_day_hours_minutes("".concat(date_string, " ").concat(time_string));

      if (!date) {
        return null;
      } // convert the local date to a time


      return this.convert_local_date_to_time(start_date, date, airport);
    } // converts a time (in hours from the start_date) to a local date,
    // accounting for timezone and DST adjustments and the fact that javascript
    // dates are always in the app's local timezone

  }, {
    key: "convert_time_to_local_date",
    value: function convert_time_to_local_date(start_date, time, airport) {
      // assume Z if no airport is given
      if (airport == null) {
        airport = z_airport;
      } // create a javascript date object


      var date = new Date(start_date + (time + airport.timezone) * (60 * 60 * 1000)); // correct for the intrinsic offset of the javascript date object

      var intrinsic_offset = this.get_timezone_offset(date);
      this.add_hours(date, -intrinsic_offset); // correct for local dst

      this.add_hours(date, this.get_dst_correction(airport, date)); // correct for the intrinsic offset again (in case it has changed)

      return this.add_hours(date, -(this.get_timezone_offset(date) - intrinsic_offset));
    } // converts a local date to a time (in hours from the start_date),
    // accounting for timezone and DST adjustments

  }, {
    key: "convert_local_date_to_time",
    value: function convert_local_date_to_time(start_date, local_date, airport) {
      // assume Z if no airport is given
      if (!airport) {
        airport = z_airport;
      } // create a utc date object


      var utc_date = Date.UTC(local_date.getFullYear(), local_date.getMonth(), local_date.getDate(), local_date.getHours(), local_date.getMinutes()); // correct for the location's offset

      utc_date -= (airport.timezone + this.get_dst_correction(airport, local_date)) * (60 * 60 * 1000); // calculate the hours since the start_date

      return (utc_date - start_date) / (60 * 60 * 1000);
    } // converts date & time strings (e.g., '2014-01-01' and '23:00') to
    // a UTC date object
    // Note: date & time strings assumed to be in Z time

  }, {
    key: "convert_z_date_time_strings_to_date",
    value: function convert_z_date_time_strings_to_date() {
      var strings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var date_string = strings.date;
      var time_string = strings.time;

      if (!date_string || !time_string) {
        return null;
      }

      var _date_string$split = date_string.split('-'),
          _date_string$split2 = _slicedToArray(_date_string$split, 3),
          y = _date_string$split2[0],
          m = _date_string$split2[1],
          d = _date_string$split2[2];

      var _time_string$split = time_string.split(':'),
          _time_string$split2 = _slicedToArray(_time_string$split, 2),
          hr = _time_string$split2[0],
          min = _time_string$split2[1];

      return Date.UTC(+y, +m - 1, +d, +hr, +min);
    } // returns the duration of a time interval in the form of [h, m]

  }, {
    key: "get_duration",
    value: function get_duration(start_time, end_time) {
      var duration = end_time - start_time;
      var hrs = Math.floor(duration);
      var mins = Math.round((duration - hrs) * 60); // since we are rounding to the nearest minute,
      // correct for possible 60 minute case

      if (mins === 60) {
        hrs += 1;
        mins = 0;
      }

      return [hrs, mins];
    } // returns the duration of a time interval in the form of a formatted string

  }, {
    key: "get_duration_string",
    value: function get_duration_string(start_time, end_time) {
      var _this$get_duration = this.get_duration(start_time, end_time),
          _this$get_duration2 = _slicedToArray(_this$get_duration, 2),
          hrs = _this$get_duration2[0],
          mins = _this$get_duration2[1];

      return this.get_duration_string_for_hours_minutes(hrs, mins);
    } // returns the hours, minutes in the form of a formatted string

  }, {
    key: "get_duration_string_for_hours_minutes",
    value: function get_duration_string_for_hours_minutes(hrs, mins) {
      if (mins === 0) {
        return "".concat(hrs, "h");
      }

      return "".concat(hrs, "h ").concat(mins, "m");
    }
  }, {
    key: "get_airport_offset_string",
    value: function get_airport_offset_string(start_date, time, airport) {
      // assume Z if no airport is given
      if (!airport) {
        airport = z_airport;
      }

      var offset = airport.timezone + this.get_dst_correction(airport, this.convert_time_to_local_date(start_date, time, airport));
      return this.format_timezone_string(offset, true);
    } // parses a javascript date for timezone offset string

  }, {
    key: "get_timezone_string",
    value: function get_timezone_string(date) {
      if (!date) {
        return null;
      }

      return this.format_timezone(date);
    } // gets the tomezone offset (in hours) for the given date

  }, {
    key: "get_timezone_offset",
    value: function get_timezone_offset(date) {
      if (!date) {
        return null;
      }

      return -date.getTimezoneOffset() / 60;
    } // gets the current javascript app offset

  }, {
    key: "get_javascript_app_offset",
    value: function get_javascript_app_offset() {
      return this.get_timezone_offset(new Date());
    } // converts a string in the format 'mm/dd/yyyy' into a UTC date

  }, {
    key: "convert_date_picker_string_to_date",
    value: function convert_date_picker_string_to_date(str) {
      if (!str) {
        return null;
      }

      var _Array$from11 = Array.from(str.split('/')),
          _Array$from12 = _slicedToArray(_Array$from11, 3),
          m = _Array$from12[0],
          d = _Array$from12[1],
          y = _Array$from12[2];

      return Date.UTC(+y, +m - 1, +d);
    } // converts a string in the format 'yyyy-mm-dd' into a UTC date

  }, {
    key: "convert_date_string_to_date",
    value: function convert_date_string_to_date(str) {
      if (!str) {
        return null;
      }

      var _Array$from13 = Array.from(str.split('-')),
          _Array$from14 = _slicedToArray(_Array$from13, 3),
          y = _Array$from14[0],
          m = _Array$from14[1],
          d = _Array$from14[2];

      return Date.UTC(+y, +m - 1, +d);
    } // adds the given number of hours to the given date

  }, {
    key: "add_hours",
    value: function add_hours(date, hours) {
      var ms = date.getTime();
      date.setTime(ms + hours * (60 * 60 * 1000));
      return date;
    } // clones a date

  }, {
    key: "clone",
    value: function clone(date) {
      return new Date(date.getTime());
    } // returns the number of hours between the two dates (always positive)

  }, {
    key: "hours_between",
    value: function hours_between(date_1, date_2) {
      return Math.abs(date_1.getTime() - date_2.getTime()) / (1000 * 60 * 60);
    } // returns a time of day number in the range of [0, 24]

  }, {
    key: "convert_time_to_time_of_day",
    value: function convert_time_to_time_of_day(start_date, time, airport) {
      var time_str = this.convert_time_to_local_date_time_strings(start_date, time, airport).time;

      var _time_str$split = time_str.split(':'),
          _time_str$split2 = _slicedToArray(_time_str$split, 2),
          h_str = _time_str$split2[0],
          m_str = _time_str$split2[1];

      return Number(h_str) + Number(m_str) / 60;
    } // determines whether two time-of-day intervals intersect
    // each interval should have numeric start_time and
    // end_time properties in [0, 24]

  }, {
    key: "do_time_of_day_intervals_intersect",
    value: function do_time_of_day_intervals_intersect() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (a.start_time == null || a.end_time == null || b.start_time == null || b.end_time == null) {
        return false;
      }

      if (a.start_time <= a.end_time && b.start_time <= b.end_time) {
        return a.start_time <= b.end_time && a.end_time >= b.start_time;
      } else if (b.start_time <= b.end_time) {
        return b.start_time <= a.end_time || b.end_time >= a.start_time;
      } else if (a.start_time <= a.end_time) {
        return a.start_time <= b.end_time || a.end_time >= b.start_time;
      }

      return true;
    } // determines if two intervals intersect
    // each interval should have a numeric start_time and end_time representing
    // hours since the start_date

  }, {
    key: "intervals_intersect",
    value: function intervals_intersect() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (a.start_time == null || a.end_time == null || b.start_time == null || b.end_time == null) {
        return false;
      }

      return a.start_time <= b.end_time && a.end_time >= b.start_time;
    } // returns true when the first interval contains the second

  }, {
    key: "interval_contains",
    value: function interval_contains() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (a.start_time == null || a.end_time == null || b.start_time == null || b.end_time == null) {
        return false;
      }

      return a.start_time <= b.start_time && a.end_time >= b.end_time;
    } // determines the minimum distance in hours between two intervals
    // each interval should have a numeric start_time and end_time representing
    // hours since the start_date

  }, {
    key: "hours_between_intervals",
    value: function hours_between_intervals() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (a.start_time == null || a.end_time == null || b.start_time == null || b.end_time == null) {
        return NaN;
      }

      if (this.intervals_intersect(a, b)) {
        return 0;
      }

      if (a.start_time < b.start_time) {
        return b.start_time - a.end_time;
      }

      return a.start_time - b.end_time;
    } // determines the minimum distance in hours between the start_times of two
    // intervals, where the start_time is hours since the start_date

  }, {
    key: "hours_between_starts",
    value: function hours_between_starts() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (a.start_time == null || b.start_time == null) {
        return NaN;
      }

      if (a.start_time < b.start_time) {
        return b.start_time - a.start_time;
      }

      return a.start_time - b.start_time;
    } // rounds the UTC date to the nearest day

  }, {
    key: "round_date_to_nearest_day",
    value: function round_date_to_nearest_day(date, round_func) {
      if (!round_func) {
        round_func = Math.round;
      }

      var day = date / (24 * 3600 * 1000);
      var result = round_func(day);
      return result * 24 * 3600 * 1000;
    } // calculates the DST correction at the given location at the given local date

  }, {
    key: "get_dst_correction",
    value: function get_dst_correction(airport, local_date) {
      var std_correction = 0; // if the location doesn't observe dst

      if (airport.dst_timezone == null) {
        return std_correction;
      }

      var dst_correction = airport.dst_timezone - airport.timezone;
      var std_interval = [airport.std_start_date, airport.std_end_date].map(this.parse_airport_dst_field);
      var dst_interval = [airport.dst_start_date, airport.dst_end_date].map(this.parse_airport_dst_field); // check if the date is within the STD interval

      if (local_date >= std_interval[0] && local_date <= std_interval[1]) {
        return std_correction;
      } // check if the date is within the DST interval


      if (local_date >= dst_interval[0] && local_date <= dst_interval[1]) {
        return dst_correction;
      } // otherwise, assume that STD-DST changes on the same days every year
      // this is clearly not correct, but will be off at most a week


      var local_month = local_date.getMonth();
      var local_day = local_date.getDate();
      var std_months = std_interval.map(function (x) {
        return x.getMonth();
      });
      var std_days = std_interval.map(function (x) {
        return x.getDate();
      });
      var dst_months = dst_interval.map(function (x) {
        return x.getMonth();
      });
      var dst_days = dst_interval.map(function (x) {
        return x.getDate();
      }); // check if within the STD interval

      if (this.is_within_intervals(std_months, std_days, local_month, local_day)) {
        return std_correction;
      } // check if within the DST interval


      if (this.is_within_intervals(dst_months, dst_days, local_month, local_day)) {
        return dst_correction;
      } // otherwise I give up; assume not in DST


      return std_correction;
    }
  }, {
    key: "is_within_intervals",
    value: function is_within_intervals(months, days, month, day) {
      if (months[0] < months[1]) {
        return (month > months[0] || month === months[0] && day >= days[0]) && (month < months[1] || month === months[1] && day < days[1]);
      }

      return month > months[0] || month === months[0] && day >= days[0] || month < months[1] || month === months[1] && day < days[1];
    } // attempts to parse an arbitrary time string into the standard format
    // the standard format is 'hh:mm' as specified by RFC3339,
    // see http://tools.ietf.org/html/rfc3339#section-5.6

  }, {
    key: "try_parse_time_string",
    value: function try_parse_time_string(time_str) {
      if (time_str == null || typeof time_str !== 'string') {
        return;
      }

      time_str = time_str.toUpperCase(); // append a leading zero if it is a 3-digit time

      if (/^\d{3}\s?([AP]M)?$/.test(time_str)) {
        time_str = "0".concat(time_str);
      }

      var _iterator12 = _createForOfIteratorHelper(try_parse_time_string_formats),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var format = _step12.value;
          var result = format(time_str);

          if (result != null) {
            return this.format_hours_minutes(result);
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    } // attempts to parse an arbitrary date string into the standard format
    // the standard format is 'yyyy-mm-dd' as specified by RFC3339,
    // see http://tools.ietf.org/html/rfc3339#section-5.6

  }, {
    key: "try_parse_date_string",
    value: function try_parse_date_string(date_str) {
      if (date_str == null || typeof date_str !== 'string') {
        return;
      }

      var _iterator13 = _createForOfIteratorHelper(try_parse_date_string_formats),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var format = _step13.value;
          var result = format(date_str);

          if (result != null) {
            return this.format_year_month_day(result);
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
  }]);

  return UtilitiesTime;
}();
//# sourceMappingURL=utilities.js.map
